import React, { useState, useEffect, useCallback } from "react";
import { getSession, login, logout, handleCallback } from "./auth";
import * as api from "./api";

const BUDGET = {
  revenue: [
    { id: "1010", acct: "1010.00.00", name: "Artist Membership (Studio Subleases)", budget: 32000, type: "earned" },
    { id: "1020", acct: "1020.00.00", name: "Workshops & Classes", budget: 0, type: "earned" },
    { id: "1030", acct: "1030.00.00", name: "Events & Public Engagement", budget: 48500, type: "earned" },
    { id: "1040", acct: "1040.00.00", name: "Mural Project", budget: 0, type: "earned" },
    { id: "1050", acct: "1050.00.00", name: "Bank Interest", budget: 0, type: "earned" },
    { id: "2010", acct: "2010.00.00", name: "Institutional Funding (Confirmed)", budget: 460000, type: "contributed" },
    { id: "2010a", acct: "2010.10.00", name: "Institutional Funding (In Progress)", budget: 650000, type: "inprogress" },
    { id: "2010b", acct: "2010.10.10", name: "Individual Funding", budget: 200000, type: "inprogress" },
    { id: "2010c", acct: "2010.10.20", name: "Corporate Sponsorships", budget: 0, type: "inprogress" },
  ],
  expenses: [
    { id: "3010.05", acct: "3010.05.00", name: "Staffing", budget: 107920 },
    { id: "3010.10", acct: "3010.10.00", name: "Occupancy (Insurance)", budget: 18900 },
    { id: "3010.15", acct: "3010.15.00", name: "Resident Artist Membership", budget: 300 },
    { id: "3010.20", acct: "3010.20.00", name: "Community Build Program", budget: 300 },
    { id: "3010.25", acct: "3010.25.00", name: "Artist Equity Fellowship", budget: 2700 },
    { id: "3010.30", acct: "3010.30.00", name: "Workshops", budget: 0 },
    { id: "3010.35", acct: "3010.35.00", name: "Mural", budget: 6000 },
    { id: "3010.40", acct: "3010.40.00", name: "Open Houses", budget: 6900 },
    { id: "3010.45", acct: "3010.45.00", name: "Art Nights", budget: 12000 },
    { id: "3010.50", acct: "3010.50.00", name: "Art Ignite", budget: 4000 },
    { id: "3010.55", acct: "3010.55.00", name: "Event Rentals", budget: 0 },
    { id: "3010.60", acct: "3010.60.00", name: "Administrative Overhead", budget: 5100 },
    { id: "3010.65", acct: "3010.65.00", name: "Contingency", budget: 34000 },
    { id: "3010.70", acct: "3010.70.00", name: "Construction (Loan to Box Shop)", budget: 1005400 },
  ],
};

const REV_STATUSES = ["Received", "Confirmed", "Applied", "Pledged", "Hoped"];
const EXP_STATUSES = ["Paid", "Committed", "Budgeted"];

const STATUS_COLORS = {
  Received: "#22c55e", Confirmed: "#3b82f6", Applied: "#f59e0b", Pledged: "#a78bfa", Hoped: "#6b7280",
  Paid: "#ef4444", Committed: "#f59e0b", Budgeted: "#6b7280",
};

const fmt = (n) => {
  if (n === 0) return "$0";
  if (Math.abs(n) >= 1000) return (n < 0 ? "-" : "") + "$" + Math.abs(n).toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  return "$" + n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

function Modal({ open, onClose, children }) {
  if (!open) return null;
  return (
    <div style={{ position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:"20px" }}
      onClick={onClose}>
      <div style={{ background:"#1a1f2e",borderRadius:12,padding:"28px 32px",maxWidth:520,width:"100%",border:"1px solid #2a3040",maxHeight:"85vh",overflowY:"auto" }}
        onClick={e=>e.stopPropagation()}>
        {children}
      </div>
    </div>
  );
}

// =============================================
// Login Screen
// =============================================
function LoginScreen() {
  return (
    <div style={{ background:"#0f1219",color:"#e2e8f0",minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'Outfit','Segoe UI',system-ui,sans-serif" }}>
      <link href="https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&family=JetBrains+Mono:wght@400;500;600;700&display=swap" rel="stylesheet" />
      <div style={{ textAlign:"center",maxWidth:400 }}>
        <div style={{ width:64,height:64,borderRadius:16,background:"linear-gradient(135deg,#c8a23c,#8b6914)",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,fontSize:28,color:"#0f1219",margin:"0 auto 24px" }}>Q</div>
        <h1 style={{ fontSize:28,fontWeight:700,margin:"0 0 8px" }}>QBOX Financial</h1>
        <p style={{ color:"#64748b",fontSize:14,margin:"0 0 32px" }}>2026 Budget Tracking · Board Access</p>
        <button onClick={login} style={{
          padding:"14px 32px",borderRadius:8,border:"none",background:"#c8a23c",color:"#0f1219",
          cursor:"pointer",fontSize:15,fontWeight:700,letterSpacing:0.3,display:"inline-flex",alignItems:"center",gap:10,
        }}>
          <svg width="18" height="18" viewBox="0 0 24 24"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/></svg>
          Sign in with Google
        </button>
        <p style={{ color:"#475569",fontSize:11,marginTop:16 }}>Access restricted to authorized board members</p>
      </div>
    </div>
  );
}

// =============================================
// Main Application
// =============================================
function QBoxFinance({ session, qbCode, onQbCodeUsed }) {
  const [transactions, setTransactions] = useState([]);
  const [bankBalance, setBankBalance] = useState(0);
  const [view, setView] = useState("dashboard");
  const [modal, setModal] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editTx, setEditTx] = useState(null);
  const [form, setForm] = useState({ amount: "", date: new Date().toISOString().slice(0,10), payerPayee: "", status: "", notes: "" });
  const [bankModal, setBankModal] = useState(false);
  const [bankInput, setBankInput] = useState("");
  const [revBudgetModal, setRevBudgetModal] = useState(false);
  const [qbConnected, setQbConnected] = useState(false);
  const [qbLoading, setQbLoading] = useState(false);
  const [qbAccounts, setQbAccounts] = useState([]);
  const [qbTransactions, setQbTransactions] = useState(null);
  const [qbBalances, setQbBalances] = useState([]);
  const [qbError, setQbError] = useState(null);
  const [qbDateRange, setQbDateRange] = useState({ startDate: "2025-01-01", endDate: new Date().toISOString().slice(0,10) });
  const [qbYearData, setQbYearData] = useState([]);
  const [qbYearLoading, setQbYearLoading] = useState(false);
  const [qbSelectedYear, setQbSelectedYear] = useState("2025");
  const [qbExpandedGroups, setQbExpandedGroups] = useState({});
  const [allocations, setAllocations] = useState({});
  const [allocModal, setAllocModal] = useState(null);
  const [allocForm, setAllocForm] = useState({});
  const [budgetItems, setBudgetItems] = useState([]);
  const [budgetModal, setBudgetModal] = useState(null);
  const [budgetForm, setBudgetForm] = useState({ name: "", name2: "", amount: "", date: new Date().toISOString().slice(0,10), ledger: "", qbRef: "", payerPayee: "", notes: "", side: "expense", months: {} });

  // Load data from API on mount
  useEffect(() => {
    (async () => {
      try {
        const [txs, settings, allocs, budgetData] = await Promise.all([
          api.getTransactions(),
          api.getSettings(),
          api.getAllocations(),
          api.getBudgetItems(),
        ]);
        setTransactions(txs || []);
        setBankBalance(settings?.bankBalance || 0);
        setAllocations(allocs || {});
        setBudgetItems(budgetData || []);
      } catch (err) {
        console.error("Failed to load data:", err);
      }
      setLoading(false);
    })();
  }, []);

  // Check QB connection status on mount
  useEffect(() => {
    (async () => {
      try {
        const status = await api.getQBStatus();
        setQbConnected(status.connected);
      } catch {}
    })();
  }, []);

  // Handle QB OAuth callback code
  useEffect(() => {
    if (!qbCode) return;
    (async () => {
      setQbLoading(true);
      setQbError(null);
      try {
        await api.exchangeQBToken(qbCode);
        setQbConnected(true);
        onQbCodeUsed();
        setView("settings");
      } catch (err) {
        setQbError("Failed to connect QuickBooks: " + err.message);
      }
      setQbLoading(false);
    })();
  }, [qbCode, onQbCodeUsed]);

  // Load QB year data
  const loadQbYear = useCallback(async (year) => {
    setQbYearLoading(true);
    try {
      const data = await api.getQBYearData(year);
      setQbYearData(data);
    } catch (err) { console.error("Failed to load QB data:", err); }
    setQbYearLoading(false);
  }, []);

  // Load QB 2025 data on mount
  useEffect(() => { loadQbYear("2025"); }, [loadQbYear]);

  const save = useCallback(async (txs) => {
    setTransactions(txs);
    // Note: individual API calls happen in submitTx/deleteTx
  }, []);

  const saveBankBalance = useCallback(async (val) => {
    setBankBalance(val);
    try { await api.updateSettings({ bankBalance: val }); } catch (err) { console.error(err); }
  }, []);

  const openAddTx = (budgetItem, side) => {
    setEditTx(null);
    setForm({ amount: "", date: new Date().toISOString().slice(0,10), payerPayee: "", status: side === "revenue" ? "Received" : "Paid", notes: "" });
    setModal({ item: budgetItem, side });
  };

  const openEditTx = (tx) => {
    const item = [...BUDGET.revenue, ...BUDGET.expenses].find(b => b.id === tx.budgetId);
    const side = BUDGET.revenue.find(b => b.id === tx.budgetId) ? "revenue" : "expense";
    setEditTx(tx);
    setForm({ amount: String(tx.amount), date: tx.date, payerPayee: tx.payerPayee, status: tx.status, notes: tx.notes || "" });
    setModal({ item, side });
  };

  const submitTx = async () => {
    const amt = parseFloat(form.amount);
    if (!amt || amt <= 0 || !form.date || !form.status) return;
    if (editTx) {
      const updated = { ...editTx, amount: amt, date: form.date, payerPayee: form.payerPayee, status: form.status, notes: form.notes };
      try {
        await api.updateTransaction(editTx.id, updated);
        setTransactions(txs => txs.map(t => t.id === editTx.id ? updated : t));
      } catch (err) { console.error(err); }
    } else {
      const tx = { id: Date.now().toString(), budgetId: modal.item.id, side: modal.side, amount: amt, date: form.date, payerPayee: form.payerPayee, status: form.status, notes: form.notes };
      try {
        await api.createTransaction(tx);
        setTransactions(txs => [...txs, tx]);
      } catch (err) { console.error(err); }
    }
    setModal(null);
  };

  const deleteTx = async (id) => {
    try {
      await api.deleteTransaction(id);
      setTransactions(txs => txs.filter(t => t.id !== id));
    } catch (err) { console.error(err); }
    setModal(null);
  };

  // Calculations
  const txForItem = (id) => transactions.filter(t => t.budgetId === id);
  const sumByStatus = (id, statuses) => transactions.filter(t => t.budgetId === id && statuses.includes(t.status)).reduce((s,t) => s + t.amount, 0);

  const totalReceived = transactions.filter(t => t.side === "revenue" && t.status === "Received").reduce((s,t) => s + t.amount, 0);
  const totalConfirmedRev = transactions.filter(t => t.side === "revenue" && t.status === "Confirmed").reduce((s,t) => s + t.amount, 0);
  const totalPipeline = transactions.filter(t => t.side === "revenue" && ["Applied","Pledged","Hoped"].includes(t.status)).reduce((s,t) => s + t.amount, 0);
  const totalPaid = transactions.filter(t => t.side === "expense" && t.status === "Paid").reduce((s,t) => s + t.amount, 0);
  const totalCommitted = transactions.filter(t => t.side === "expense" && t.status === "Committed").reduce((s,t) => s + t.amount, 0);
  const totalBudgeted = transactions.filter(t => t.side === "expense" && t.status === "Budgeted").reduce((s,t) => s + t.amount, 0);
  const availableCash = bankBalance - totalCommitted;

  const totalBudgetRevenue = BUDGET.revenue.reduce((s,r) => s + r.budget, 0);
  const totalBudgetExpense = BUDGET.expenses.reduce((s,e) => s + e.budget, 0);

  const getMonthlyData = () => {
    const months = {};
    const year = new Date().getFullYear();
    for (let m = 0; m < 12; m++) {
      const key = `${year}-${String(m+1).padStart(2,"0")}`;
      months[key] = { revenue: [], expenses: [] };
    }
    transactions.forEach(tx => {
      const key = tx.date.slice(0,7);
      if (months[key]) {
        if (tx.side === "revenue") months[key].revenue.push(tx);
        else months[key].expenses.push(tx);
      }
    });
    return months;
  };

  if (loading) return <div style={{ background:"#0f1219",color:"#94a3b8",minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'JetBrains Mono',monospace" }}>Loading...</div>;

  const navBtn = (label, v) => (
    <button key={v} onClick={() => setView(v)} style={{
      padding: "8px 18px", borderRadius: 6, border: "none", cursor: "pointer", fontSize: 13, fontWeight: 600, letterSpacing: 0.3,
      background: view === v ? "#c8a23c" : "transparent", color: view === v ? "#0f1219" : "#94a3b8",
      transition: "all 0.2s"
    }}>{label}</button>
  );

  const statCard = (label, value, color, sub) => (
    <div style={{ background:"#151a26",borderRadius:10,padding:"18px 22px",border:"1px solid #1e2536",flex:"1 1 200px",minWidth:180 }}>
      <div style={{ fontSize:11,textTransform:"uppercase",letterSpacing:1.2,color:"#64748b",marginBottom:6 }}>{label}</div>
      <div style={{ fontSize:28,fontWeight:700,color,fontFamily:"'JetBrains Mono',monospace" }}>{fmt(value)}</div>
      {sub && <div style={{ fontSize:11,color:"#475569",marginTop:4 }}>{sub}</div>}
    </div>
  );

  return (
    <div style={{ background:"#0f1219",color:"#e2e8f0",minHeight:"100vh",fontFamily:"'Outfit','Segoe UI',system-ui,sans-serif" }}>
      <link href="https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&family=JetBrains+Mono:wght@400;500;600;700&display=swap" rel="stylesheet" />

      {/* Header */}
      <div style={{ background:"#151a26",borderBottom:"1px solid #1e2536",padding:"16px 24px",display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:12 }}>
        <div style={{ display:"flex",alignItems:"center",gap:14 }}>
          <div style={{ width:36,height:36,borderRadius:8,background:"linear-gradient(135deg,#c8a23c,#8b6914)",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,fontSize:16,color:"#0f1219" }}>Q</div>
          <div>
            <div style={{ fontWeight:700,fontSize:17,letterSpacing:0.5 }}>QBOX Financial</div>
            <div style={{ fontSize:11,color:"#64748b",letterSpacing:0.5 }}>2026 BUDGET TRACKING</div>
          </div>
        </div>
        <div style={{ display:"flex",alignItems:"center",gap:16 }}>
          <div style={{ display:"flex",gap:4,background:"#0f1219",borderRadius:8,padding:4 }}>
            {navBtn("Dashboard","dashboard")}
            {navBtn("Budget","budget")}
            {navBtn("Revenue","revenue")}
            {navBtn("Expenses","expenses")}
            {navBtn("Monthly","monthly")}
            {navBtn("QuickBooks","quickbooks")}
            {navBtn("Settings","settings")}
          </div>
          <div style={{ display:"flex",alignItems:"center",gap:10,borderLeft:"1px solid #1e2536",paddingLeft:16 }}>
            <span style={{ fontSize:12,color:"#94a3b8" }}>{session.name}</span>
            <button onClick={logout} style={{ padding:"5px 12px",borderRadius:5,border:"1px solid #2a3040",background:"transparent",color:"#64748b",cursor:"pointer",fontSize:11 }}>Sign Out</button>
          </div>
        </div>
      </div>

      <div style={{ padding:"20px 24px",maxWidth:1200,margin:"0 auto" }}>

        {/* DASHBOARD */}
        {view === "dashboard" && (() => {
          const revItems = budgetItems.filter(b => b.side === "revenue");
          const expItems = budgetItems.filter(b => b.side === "expense");
          const totalBudgetRev = revItems.reduce((s,b) => s + (b.amount || 0), 0);
          const totalBudgetExp = expItems.reduce((s,b) => s + (b.amount || 0), 0);
          const netBudget = totalBudgetRev - totalBudgetExp;

          const renderGrid = (items, label, color) => (
            <>
              <tr><td colSpan={15} style={{ padding:"8px 10px",color,fontWeight:700,fontSize:11,textTransform:"uppercase",letterSpacing:1,background:"#0f1219",borderBottom:"1px solid #1e2536" }}>{label}</td></tr>
              {items.map(item => (
                <tr key={item.id} style={{ borderBottom:"1px solid #1a1f2e" }}>
                  <td title={item.name2 ? `${item.name}\n${item.name2}` : item.name} style={{ padding:"6px 10px",color:"#e2e8f0",fontSize:11,position:"sticky",left:0,background:"#151a26",zIndex:1,minWidth:200 }}>{item.name.length > 22 ? item.name.slice(0,20)+"…" : item.name}</td>
                  <td style={{ padding:"6px 6px",textAlign:"right",fontFamily:"'JetBrains Mono',monospace",color:"#94a3b8",fontSize:11 }}>{fmt(item.amount)}</td>
                  {MONTHS.map((_,i) => {
                    const mk = String(i+1).padStart(2,"0");
                    const proj = (item.months || {})[mk] || 0;
                    return <td key={i} style={{ padding:"6px 6px",textAlign:"right",fontFamily:"'JetBrains Mono',monospace",fontSize:11,color: proj > 0 ? "#c8a23c" : "#2a3040" }}>{proj > 0 ? fmt(proj) : "—"}</td>;
                  })}
                  <td style={{ padding:"6px 6px",textAlign:"right",fontFamily:"'JetBrains Mono',monospace",fontSize:11,color: Object.values(item.months||{}).reduce((s,v)=>s+v,0) === item.amount ? "#22c55e" : "#f59e0b" }}>{Object.values(item.months||{}).reduce((s,v)=>s+v,0) > 0 ? fmt(Object.values(item.months||{}).reduce((s,v)=>s+v,0)) : "—"}</td>
                </tr>
              ))}
            </>
          );

          return (
            <div>
              <h2 style={{ fontSize:14,textTransform:"uppercase",letterSpacing:1.5,color:"#c8a23c",margin:"0 0 14px",fontWeight:700 }}>Monthly Cash Flow Forecast — 2026</h2>
              {budgetItems.length === 0 ? (
                <div style={{ background:"#151a26",borderRadius:10,border:"1px solid #1e2536",padding:"40px",textAlign:"center" }}>
                  <div style={{ fontSize:14,color:"#64748b" }}>No budget items entered yet.</div>
                  <div style={{ fontSize:12,color:"#475569",marginTop:8 }}>Go to the Budget tab to create budget line items.</div>
                </div>
              ) : (
                <div style={{ background:"#151a26",borderRadius:10,border:"1px solid #1e2536",overflow:"auto" }}>
                  <table style={{ width:"100%",borderCollapse:"collapse",fontSize:11,minWidth:1100 }}>
                    <thead>
                      <tr style={{ borderBottom:"1px solid #1e2536" }}>
                        <th style={{ padding:"8px 10px",textAlign:"left",color:"#64748b",fontWeight:600,fontSize:10,textTransform:"uppercase",position:"sticky",left:0,background:"#151a26",minWidth:200,zIndex:1 }}>Account</th>
                        <th style={{ padding:"8px 6px",textAlign:"right",color:"#64748b",fontWeight:600,fontSize:10,textTransform:"uppercase",minWidth:70 }}>Budget</th>
                        {MONTHS.map(m => <th key={m} style={{ padding:"8px 6px",textAlign:"right",color:"#64748b",fontWeight:600,fontSize:10,textTransform:"uppercase",minWidth:65 }}>{m}</th>)}
                        <th style={{ padding:"8px 6px",textAlign:"right",color:"#64748b",fontWeight:600,fontSize:10,textTransform:"uppercase",minWidth:70 }}>Alloc'd</th>
                      </tr>
                    </thead>
                    <tbody>
                      {renderGrid(revItems, "Revenue", "#22c55e")}
                      <tr style={{ borderTop:"2px solid #2a3040" }}>
                        <td style={{ padding:"8px 10px",color:"#22c55e",fontWeight:700,fontSize:11,position:"sticky",left:0,background:"#151a26",zIndex:1 }}>REVENUE TOTAL</td>
                        <td style={{ padding:"8px 6px",textAlign:"right",fontFamily:"'JetBrains Mono',monospace",color:"#22c55e",fontWeight:700,fontSize:11 }}>{fmt(totalBudgetRev)}</td>
                        {MONTHS.map((_,i) => { const mk = String(i+1).padStart(2,"0"); const v = revItems.reduce((s,b) => s + ((b.months||{})[mk]||0), 0); return <td key={i} style={{ padding:"8px 6px",textAlign:"right",fontFamily:"'JetBrains Mono',monospace",color: v > 0 ? "#c8a23c" : "#2a3040",fontWeight:700,fontSize:11 }}>{v > 0 ? fmt(v) : "—"}</td>; })}
                        <td style={{ padding:"8px 6px" }}></td>
                      </tr>
                      {renderGrid(expItems, "Expenses", "#ef4444")}
                      <tr style={{ borderTop:"2px solid #2a3040" }}>
                        <td style={{ padding:"8px 10px",color:"#ef4444",fontWeight:700,fontSize:11,position:"sticky",left:0,background:"#151a26",zIndex:1 }}>EXPENSE TOTAL</td>
                        <td style={{ padding:"8px 6px",textAlign:"right",fontFamily:"'JetBrains Mono',monospace",color:"#ef4444",fontWeight:700,fontSize:11 }}>{fmt(totalBudgetExp)}</td>
                        {MONTHS.map((_,i) => { const mk = String(i+1).padStart(2,"0"); const v = expItems.reduce((s,b) => s + ((b.months||{})[mk]||0), 0); return <td key={i} style={{ padding:"8px 6px",textAlign:"right",fontFamily:"'JetBrains Mono',monospace",color: v > 0 ? "#c8a23c" : "#2a3040",fontWeight:700,fontSize:11 }}>{v > 0 ? fmt(v) : "—"}</td>; })}
                        <td style={{ padding:"8px 6px" }}></td>
                      </tr>
                      <tr style={{ borderTop:"2px solid #c8a23c",background:"#1a1a10" }}>
                        <td style={{ padding:"10px 10px",color:"#c8a23c",fontWeight:700,fontSize:12,position:"sticky",left:0,background:"#1a1a10",zIndex:1 }}>NET CASH FLOW</td>
                        <td style={{ padding:"10px 6px",textAlign:"right",fontFamily:"'JetBrains Mono',monospace",color: netBudget > 0 ? "#22c55e" : netBudget < 0 ? "#ef4444" : "#2a3040",fontWeight:700,fontSize:11 }}>{fmt(netBudget)}</td>
                        {MONTHS.map((_,i) => { const mk = String(i+1).padStart(2,"0"); const rev = revItems.reduce((s,b) => s + ((b.months||{})[mk]||0), 0); const exp = expItems.reduce((s,b) => s + ((b.months||{})[mk]||0), 0); const net = rev - exp; return <td key={i} style={{ padding:"10px 6px",textAlign:"right",fontFamily:"'JetBrains Mono',monospace",color: net > 0 ? "#22c55e" : net < 0 ? "#ef4444" : "#2a3040",fontWeight:700,fontSize:11 }}>{net !== 0 ? fmt(net) : "—"}</td>; })}
                        <td style={{ padding:"10px 6px" }}></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          );
        })()}

        {/* BUDGET TAB */}
        {view === "budget" && (() => {
          const revItems = budgetItems.filter(b => b.side === "revenue");
          const expItems = budgetItems.filter(b => b.side === "expense");
          const totalBudgetRev = revItems.reduce((s,b) => s + (b.amount || 0), 0);
          const totalBudgetExp = expItems.reduce((s,b) => s + (b.amount || 0), 0);
          const netBudget = totalBudgetRev - totalBudgetExp;

          const openNewBudget = (side) => {
            setBudgetModal({ mode: "new", side });
            setBudgetForm({ name: "", name2: "", amount: "", date: new Date().toISOString().slice(0,10), ledger: "", qbRef: "", payerPayee: "", notes: "", side, months: {} });
          };
          const openEditBudget = (item) => {
            setBudgetModal({ mode: "edit", side: item.side, item });
            setBudgetForm({ ...item, amount: String(item.amount), months: item.months || {} });
          };

          const exportCSV = () => {
            let csv = "Type,Account Name,Secondary Account Name,Budget,Ledger,QB Ref,Payer," + MONTHS.join(",") + ",Allocated\n";
            [...revItems, ...expItems].forEach(item => {
              const allocTotal = Object.values(item.months || {}).reduce((s,v) => s + (v||0), 0);
              const monthVals = MONTHS.map((_,i) => (item.months||{})[String(i+1).padStart(2,"0")]||0).join(",");
              csv += `"${item.side}","${item.name}","${item.name2||""}",${item.amount},"${item.ledger||""}","${item.qbRef||""}","${item.payerPayee||""}",${monthVals},${allocTotal}\n`;
            });
            const blob = new Blob([csv], {type:"text/csv"});
            const a = document.createElement("a"); a.href = URL.createObjectURL(blob); a.download = "QBox_Budget_2026.csv"; a.click();
          };

          const renderBudgetRows = (items) => items.map(item => {
            const allocTotal = Object.values(item.months || {}).reduce((s,v) => s + (v||0), 0);
            return (
              <tr key={item.id} style={{ borderBottom:"1px solid #1a1f2e",cursor:"pointer",transition:"background 0.15s" }}
                onClick={() => openEditBudget(item)}
                onMouseEnter={e => e.currentTarget.style.background="#1a2030"}
                onMouseLeave={e => e.currentTarget.style.background="transparent"}>
                <td title={item.name2 ? `${item.name}\n${item.name2}` : item.name} style={{ padding:"6px 10px",color:"#e2e8f0",fontSize:11,position:"sticky",left:0,background:"inherit",zIndex:1,minWidth:200 }}>{item.name.length > 22 ? item.name.slice(0,20)+"…" : item.name}</td>
                <td style={{ padding:"6px 6px",textAlign:"right",fontFamily:"'JetBrains Mono',monospace",color:"#94a3b8",fontSize:11 }}>{fmt(item.amount)}</td>
                {MONTHS.map((_,i) => { const mk = String(i+1).padStart(2,"0"); const v = (item.months||{})[mk]||0; return <td key={i} style={{ padding:"6px 6px",textAlign:"right",fontFamily:"'JetBrains Mono',monospace",fontSize:11,color: v > 0 ? "#c8a23c" : "#2a3040" }}>{v > 0 ? fmt(v) : "—"}</td>; })}
                <td style={{ padding:"6px 6px",textAlign:"right",fontFamily:"'JetBrains Mono',monospace",fontSize:11,color: allocTotal === item.amount ? "#22c55e" : allocTotal > 0 ? "#f59e0b" : "#2a3040" }}>{allocTotal > 0 ? fmt(allocTotal) : "—"}</td>
              </tr>
            );
          });

          return (
            <div>
              <div style={{ display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:14 }}>
                <h2 style={{ fontSize:14,textTransform:"uppercase",letterSpacing:1.5,color:"#c8a23c",margin:0,fontWeight:700 }}>Monthly Cash Flow Forecast — 2026</h2>
                <button onClick={exportCSV} style={{ padding:"6px 14px",borderRadius:6,border:"1px solid #2a3040",background:"transparent",color:"#94a3b8",cursor:"pointer",fontSize:11,fontWeight:600 }}>Export CSV</button>
              </div>
              <div style={{ fontSize:11,color:"#475569",marginBottom:12 }}>Click any row to edit.</div>
              <div style={{ background:"#151a26",borderRadius:10,border:"1px solid #1e2536",overflow:"auto" }}>
                <table style={{ width:"100%",borderCollapse:"collapse",fontSize:11,minWidth:1100 }}>
                  <thead>
                    <tr style={{ borderBottom:"1px solid #1e2536" }}>
                      <th style={{ padding:"8px 10px",textAlign:"left",color:"#64748b",fontWeight:600,fontSize:10,textTransform:"uppercase",position:"sticky",left:0,background:"#151a26",minWidth:200,zIndex:1 }}>Account</th>
                      <th style={{ padding:"8px 6px",textAlign:"right",color:"#64748b",fontWeight:600,fontSize:10,textTransform:"uppercase",minWidth:70 }}>Budget</th>
                      {MONTHS.map(m => <th key={m} style={{ padding:"8px 6px",textAlign:"right",color:"#64748b",fontWeight:600,fontSize:10,textTransform:"uppercase",minWidth:65 }}>{m}</th>)}
                      <th style={{ padding:"8px 6px",textAlign:"right",color:"#64748b",fontWeight:600,fontSize:10,textTransform:"uppercase",minWidth:70 }}>Alloc'd</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr><td colSpan={15} style={{ padding:"8px 10px",color:"#22c55e",fontWeight:700,fontSize:11,textTransform:"uppercase",letterSpacing:1,background:"#0f1219",borderBottom:"1px solid #1e2536" }}>
                      <div style={{ display:"flex",alignItems:"center",gap:10 }}>
                        <button onClick={() => openNewBudget("revenue")} style={{ padding:"2px 10px",borderRadius:4,border:"1px solid #22c55e40",background:"transparent",color:"#22c55e",cursor:"pointer",fontSize:12,fontWeight:700 }}>+</button>
                        <span>Revenue</span>
                      </div>
                    </td></tr>
                    {renderBudgetRows(revItems)}
                    <tr style={{ borderTop:"2px solid #2a3040" }}>
                      <td style={{ padding:"8px 10px",color:"#22c55e",fontWeight:700,fontSize:11,position:"sticky",left:0,background:"#151a26",zIndex:1 }}>REVENUE TOTAL</td>
                      <td style={{ padding:"8px 6px",textAlign:"right",fontFamily:"'JetBrains Mono',monospace",color:"#22c55e",fontWeight:700,fontSize:11 }}>{fmt(totalBudgetRev)}</td>
                      {MONTHS.map((_,i) => { const mk = String(i+1).padStart(2,"0"); const v = revItems.reduce((s,b) => s + ((b.months||{})[mk]||0), 0); return <td key={i} style={{ padding:"8px 6px",textAlign:"right",fontFamily:"'JetBrains Mono',monospace",color: v > 0 ? "#c8a23c" : "#2a3040",fontWeight:700,fontSize:11 }}>{v > 0 ? fmt(v) : "—"}</td>; })}
                      <td style={{ padding:"8px 6px" }}></td>
                    </tr>

                    <tr><td colSpan={15} style={{ padding:"8px 10px",color:"#ef4444",fontWeight:700,fontSize:11,textTransform:"uppercase",letterSpacing:1,background:"#0f1219",borderBottom:"1px solid #1e2536" }}>
                      <div style={{ display:"flex",alignItems:"center",gap:10 }}>
                        <button onClick={() => openNewBudget("expense")} style={{ padding:"2px 10px",borderRadius:4,border:"1px solid #ef444440",background:"transparent",color:"#ef4444",cursor:"pointer",fontSize:12,fontWeight:700 }}>+</button>
                        <span>Expenses</span>
                      </div>
                    </td></tr>
                    {renderBudgetRows(expItems)}
                    <tr style={{ borderTop:"2px solid #2a3040" }}>
                      <td style={{ padding:"8px 10px",color:"#ef4444",fontWeight:700,fontSize:11,position:"sticky",left:0,background:"#151a26",zIndex:1 }}>EXPENSE TOTAL</td>
                      <td style={{ padding:"8px 6px",textAlign:"right",fontFamily:"'JetBrains Mono',monospace",color:"#ef4444",fontWeight:700,fontSize:11 }}>{fmt(totalBudgetExp)}</td>
                      {MONTHS.map((_,i) => { const mk = String(i+1).padStart(2,"0"); const v = expItems.reduce((s,b) => s + ((b.months||{})[mk]||0), 0); return <td key={i} style={{ padding:"8px 6px",textAlign:"right",fontFamily:"'JetBrains Mono',monospace",color: v > 0 ? "#c8a23c" : "#2a3040",fontWeight:700,fontSize:11 }}>{v > 0 ? fmt(v) : "—"}</td>; })}
                      <td style={{ padding:"8px 6px" }}></td>
                    </tr>

                    <tr style={{ borderTop:"2px solid #c8a23c",background:"#1a1a10" }}>
                      <td style={{ padding:"10px 10px",color:"#c8a23c",fontWeight:700,fontSize:12,position:"sticky",left:0,background:"#1a1a10",zIndex:1 }}>NET CASH FLOW</td>
                      <td style={{ padding:"10px 6px",textAlign:"right",fontFamily:"'JetBrains Mono',monospace",color: netBudget > 0 ? "#22c55e" : netBudget < 0 ? "#ef4444" : "#2a3040",fontWeight:700,fontSize:11 }}>{fmt(netBudget)}</td>
                      {MONTHS.map((_,i) => { const mk = String(i+1).padStart(2,"0"); const rev = revItems.reduce((s,b) => s + ((b.months||{})[mk]||0), 0); const exp = expItems.reduce((s,b) => s + ((b.months||{})[mk]||0), 0); const net = rev - exp; return <td key={i} style={{ padding:"10px 6px",textAlign:"right",fontFamily:"'JetBrains Mono',monospace",color: net > 0 ? "#22c55e" : net < 0 ? "#ef4444" : "#2a3040",fontWeight:700,fontSize:11 }}>{net !== 0 ? fmt(net) : "—"}</td>; })}
                      <td style={{ padding:"10px 6px" }}></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          );
        })()}

        {/* REVENUE VIEW */}
        {view === "revenue" && (
          <div>
            <h2 style={{ fontSize:14,textTransform:"uppercase",letterSpacing:1.5,color:"#c8a23c",margin:"0 0 18px",fontWeight:700 }}>Revenue Tracking</h2>
            {BUDGET.revenue.map(rev => {
              const txs = txForItem(rev.id);
              const total = txs.reduce((s,t) => s + t.amount, 0);
              return (
                <div key={rev.id} style={{ background:"#151a26",borderRadius:10,border:"1px solid #1e2536",marginBottom:12,overflow:"hidden" }}>
                  <div style={{ display:"flex",alignItems:"center",justifyContent:"space-between",padding:"14px 18px",cursor:"pointer" }}
                    onClick={() => openAddTx(rev, "revenue")}
                    onMouseEnter={e => e.currentTarget.style.background="#1a2030"}
                    onMouseLeave={e => e.currentTarget.style.background="transparent"}>
                    <div>
                      <div style={{ fontWeight:600,fontSize:14 }}>{rev.name}</div>
                      <div style={{ fontSize:11,color:"#64748b",marginTop:4,display:"flex",gap:16,fontFamily:"'JetBrains Mono',monospace" }}>
                        <span>{rev.acct}</span>
                        <span>Budget: {fmt(rev.budget)}</span>
                        <span>Actual: <span style={{ color: total > 0 ? "#22c55e" : "#64748b" }}>{fmt(total)}</span></span>
                        <span>Diff: <span style={{ color: rev.budget - total > 0 ? "#f59e0b" : rev.budget - total === 0 ? "#22c55e" : "#3b82f6" }}>{fmt(rev.budget - total)}</span></span>
                      </div>
                    </div>
                    <div style={{ textAlign:"right" }}>
                      <button style={{ marginTop:4,padding:"4px 12px",borderRadius:5,border:"1px solid #2a3040",background:"transparent",color:"#c8a23c",cursor:"pointer",fontSize:11,fontWeight:600 }}>+ Add</button>
                    </div>
                  </div>
                  {txs.length > 0 && (
                    <div style={{ borderTop:"1px solid #1e2536",padding:"8px 18px 12px" }}>
                      {txs.map(tx => (
                        <div key={tx.id} style={{ display:"flex",alignItems:"center",justifyContent:"space-between",padding:"6px 0",fontSize:12,cursor:"pointer" }}
                          onClick={(e) => { e.stopPropagation(); openEditTx(tx); }}>
                          <div style={{ display:"flex",alignItems:"center",gap:8 }}>
                            <span style={{ display:"inline-block",width:8,height:8,borderRadius:4,background:STATUS_COLORS[tx.status] }} />
                            <span style={{ color:"#94a3b8" }}>{tx.date}</span>
                            <span style={{ color:"#e2e8f0" }}>{tx.payerPayee || "—"}</span>
                            <span style={{ color:"#64748b",fontSize:11,padding:"1px 6px",borderRadius:3,background:"#1a1f2e" }}>{tx.status}</span>
                          </div>
                          <span style={{ fontFamily:"'JetBrains Mono',monospace",color:"#22c55e" }}>{fmt(tx.amount)}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}

        {/* EXPENSES VIEW */}
        {view === "expenses" && (
          <div>
            <h2 style={{ fontSize:14,textTransform:"uppercase",letterSpacing:1.5,color:"#c8a23c",margin:"0 0 18px",fontWeight:700 }}>Expense Tracking</h2>
            {BUDGET.expenses.map(exp => {
              const txs = txForItem(exp.id);
              const total = txs.reduce((s,t) => s + t.amount, 0);
              return (
                <div key={exp.id} style={{ background:"#151a26",borderRadius:10,border:"1px solid #1e2536",marginBottom:12,overflow:"hidden" }}>
                  <div style={{ display:"flex",alignItems:"center",justifyContent:"space-between",padding:"14px 18px",cursor:"pointer" }}
                    onClick={() => openAddTx(exp, "expense")}
                    onMouseEnter={e => e.currentTarget.style.background="#1a2030"}
                    onMouseLeave={e => e.currentTarget.style.background="transparent"}>
                    <div>
                      <div style={{ fontWeight:600,fontSize:14 }}>{exp.name}</div>
                      <div style={{ fontSize:11,color:"#64748b",marginTop:4,display:"flex",gap:16,fontFamily:"'JetBrains Mono',monospace" }}>
                        <span>{exp.acct}</span>
                        <span>Budget: {fmt(exp.budget)}</span>
                        <span>Actual: <span style={{ color: total > 0 ? "#ef4444" : "#64748b" }}>{fmt(total)}</span></span>
                        <span>Diff: <span style={{ color: exp.budget - total > 0 ? "#22c55e" : exp.budget - total === 0 ? "#64748b" : "#ef4444" }}>{fmt(exp.budget - total)}</span></span>
                      </div>
                    </div>
                    <div style={{ textAlign:"right" }}>
                      <button style={{ marginTop:4,padding:"4px 12px",borderRadius:5,border:"1px solid #2a3040",background:"transparent",color:"#c8a23c",cursor:"pointer",fontSize:11,fontWeight:600 }}>+ Add</button>
                    </div>
                  </div>
                  {txs.length > 0 && (
                    <div style={{ borderTop:"1px solid #1e2536",padding:"8px 18px 12px" }}>
                      {txs.map(tx => (
                        <div key={tx.id} style={{ display:"flex",alignItems:"center",justifyContent:"space-between",padding:"6px 0",fontSize:12,cursor:"pointer" }}
                          onClick={(e) => { e.stopPropagation(); openEditTx(tx); }}>
                          <div style={{ display:"flex",alignItems:"center",gap:8 }}>
                            <span style={{ display:"inline-block",width:8,height:8,borderRadius:4,background:STATUS_COLORS[tx.status] }} />
                            <span style={{ color:"#94a3b8" }}>{tx.date}</span>
                            <span style={{ color:"#e2e8f0" }}>{tx.payerPayee || "—"}</span>
                            <span style={{ color:"#64748b",fontSize:11,padding:"1px 6px",borderRadius:3,background:"#1a1f2e" }}>{tx.status}</span>
                          </div>
                          <span style={{ fontFamily:"'JetBrains Mono',monospace",color:"#ef4444" }}>{fmt(tx.amount)}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}

        {/* MONTHLY VIEW */}
        {view === "monthly" && (
          <div>
            <h2 style={{ fontSize:14,textTransform:"uppercase",letterSpacing:1.5,color:"#c8a23c",margin:"0 0 18px",fontWeight:700 }}>Monthly Transaction Log — 2026</h2>
            {(() => {
              const data = getMonthlyData();
              const currentMonth = new Date().getMonth();
              return Object.entries(data).map(([key, val], idx) => {
                const hasData = val.revenue.length + val.expenses.length > 0;
                const isFuture = idx > currentMonth;
                const revTotal = val.revenue.reduce((s,t) => s + t.amount, 0);
                const expTotal = val.expenses.reduce((s,t) => s + t.amount, 0);
                const getBudgetName = (id) => [...BUDGET.revenue,...BUDGET.expenses].find(b=>b.id===id)?.name || id;
                return (
                  <div key={key} style={{ background:"#151a26",borderRadius:10,border:"1px solid #1e2536",marginBottom:10,overflow:"hidden",opacity: !hasData && isFuture ? 0.5 : 1 }}>
                    <div style={{ display:"flex",alignItems:"center",justifyContent:"space-between",padding:"12px 18px" }}>
                      <div style={{ display:"flex",alignItems:"center",gap:10 }}>
                        <span style={{ fontWeight:700,fontSize:15 }}>{MONTHS[idx]}</span>
                        {isFuture && !hasData && <span style={{ fontSize:10,color:"#475569",background:"#1a1f2e",padding:"2px 8px",borderRadius:3 }}>FUTURE</span>}
                        {idx === currentMonth && <span style={{ fontSize:10,color:"#c8a23c",background:"#2a2210",padding:"2px 8px",borderRadius:3 }}>CURRENT</span>}
                      </div>
                      {hasData && (
                        <div style={{ display:"flex",gap:16,fontSize:12,fontFamily:"'JetBrains Mono',monospace" }}>
                          <span style={{ color:"#22c55e" }}>+{fmt(revTotal)}</span>
                          <span style={{ color:"#ef4444" }}>−{fmt(expTotal)}</span>
                          <span style={{ color: revTotal - expTotal >= 0 ? "#3b82f6" : "#f59e0b",fontWeight:600 }}>Net {fmt(revTotal - expTotal)}</span>
                        </div>
                      )}
                    </div>
                    {hasData && (
                      <div style={{ borderTop:"1px solid #1e2536",padding:"8px 18px 12px" }}>
                        {[...val.revenue.map(t=>({...t,_side:"rev"})), ...val.expenses.map(t=>({...t,_side:"exp"}))]
                          .sort((a,b) => a.date.localeCompare(b.date))
                          .map(tx => (
                          <div key={tx.id} style={{ display:"flex",alignItems:"center",justifyContent:"space-between",padding:"5px 0",fontSize:12,cursor:"pointer" }}
                            onClick={() => openEditTx(tx)}>
                            <div style={{ display:"flex",alignItems:"center",gap:8,flexWrap:"wrap" }}>
                              <span style={{ display:"inline-block",width:8,height:8,borderRadius:4,background:STATUS_COLORS[tx.status] }} />
                              <span style={{ color:"#64748b" }}>{tx.date.slice(5)}</span>
                              <span style={{ color:"#e2e8f0",fontWeight:500 }}>{getBudgetName(tx.budgetId)}</span>
                              {tx.payerPayee && <span style={{ color:"#94a3b8" }}>· {tx.payerPayee}</span>}
                              <span style={{ fontSize:10,padding:"1px 6px",borderRadius:3,background:"#1a1f2e",color:"#64748b" }}>{tx.status}</span>
                            </div>
                            <span style={{ fontFamily:"'JetBrains Mono',monospace",color: tx._side === "rev" ? "#22c55e" : "#ef4444",fontWeight:500 }}>
                              {tx._side === "rev" ? "+" : "−"}{fmt(tx.amount)}
                            </span>
                          </div>
                        ))}
                      </div>
                    )}
                    {!hasData && (
                      <div style={{ padding:"0 18px 12px",fontSize:12,color:"#475569" }}>
                        {isFuture ? "No commitments recorded" : "No transactions recorded"}
                      </div>
                    )}
                  </div>
                );
              });
            })()}

            {(() => {
              const futureCommitted = transactions.filter(t => t.status === "Committed" && t.side === "expense");
              if (futureCommitted.length === 0) return null;
              const getBudgetName = (id) => [...BUDGET.revenue,...BUDGET.expenses].find(b=>b.id===id)?.name || id;
              return (
                <div style={{ marginTop:20 }}>
                  <h3 style={{ fontSize:13,textTransform:"uppercase",letterSpacing:1.2,color:"#f59e0b",margin:"0 0 12px",fontWeight:700 }}>Outstanding Commitments</h3>
                  <div style={{ background:"#1a1a10",borderRadius:10,border:"1px solid #3d3510",padding:"14px 18px" }}>
                    {futureCommitted.map(tx => (
                      <div key={tx.id} style={{ display:"flex",alignItems:"center",justifyContent:"space-between",padding:"5px 0",fontSize:12 }}>
                        <div style={{ display:"flex",alignItems:"center",gap:8 }}>
                          <span style={{ color:"#f59e0b" }}>●</span>
                          <span style={{ color:"#e2e8f0" }}>{getBudgetName(tx.budgetId)}</span>
                          {tx.payerPayee && <span style={{ color:"#94a3b8" }}>· {tx.payerPayee}</span>}
                          <span style={{ color:"#64748b" }}>{tx.date}</span>
                        </div>
                        <span style={{ fontFamily:"'JetBrains Mono',monospace",color:"#f59e0b",fontWeight:600 }}>{fmt(tx.amount)}</span>
                      </div>
                    ))}
                    <div style={{ borderTop:"1px solid #3d3510",marginTop:8,paddingTop:8,display:"flex",justifyContent:"space-between",fontSize:13,fontWeight:700 }}>
                      <span style={{ color:"#f59e0b" }}>Total Committed</span>
                      <span style={{ fontFamily:"'JetBrains Mono',monospace",color:"#f59e0b" }}>{fmt(futureCommitted.reduce((s,t)=>s+t.amount,0))}</span>
                    </div>
                  </div>
                </div>
              );
            })()}
          </div>
        )}

        {/* QUICKBOOKS VIEW */}
        {view === "quickbooks" && (() => {
          // Category mapping for summary groups
          const categoryMap = {
            "Donations & Grants": [
              "Contributed income:Corporate & foundation grants",
              "Contributed income:Donations by individuals and businesses I",
              "Contributed income:Donations directed by individuals and Bus",
              "Contributed income:Foundation Grant",
              "Contributed income:Online Fundraising Platforms",
            ],
            "Event Revenue": ["Special Events", "Services"],
            "Staffing & Contractors": ["Non Employee Compensation - Via PayPal"],
            "Professional Services": ["Contract & professional fees", "Contract & professional fees:Legal fees"],
            "Construction": ["Loan to Box Shop"],
            "Operations": ["Insurance", "Office expenses:Bank fees & service charges", "Office expenses:Office supplies",
              "Office expenses:Shipping & postage", "Office expenses:Software & apps", "Advertising & marketing",
              "Advertising & marketing:Schwag", "Job Supplies", "Travel", "Schwab", "Program Expense - Artist Stipend"],
          };

          // Class to group mapping (primary)
          const classMap = {
            "staffing": "Staffing & Contractors",
            "admin": "Operations",
            "open house": "Operations",
            "vandyke": "Construction",
            "press": "Operations",
            "fundraising": "Operations",
            "loan": "Construction",
            "artist stipends": "Operations",
            "sparks and spirits": "Operations",
          };

          const getGroup = (tx) => {
            // Use Class first
            if (tx.class && classMap[tx.class]) return classMap[tx.class];
            // Fallback to category
            for (const [group, cats] of Object.entries(categoryMap)) {
              if (cats.includes(tx.category)) return group;
            }
            return "Other";
          };

          // Group transactions
          const grouped = {};
          qbYearData.forEach(tx => {
            const group = getGroup(tx);
            if (!grouped[group]) grouped[group] = [];
            grouped[group].push(tx);
          });

          // Sort groups: revenue first, then expenses
          const revenueGroups = ["Donations & Grants", "Event Revenue"];
          const expenseGroups = ["Staffing & Contractors", "Professional Services", "Construction", "Operations"];
          const allGroups = [...revenueGroups, ...expenseGroups, "Other"].filter(g => grouped[g]);

          const totalIn = qbYearData.filter(t => t.amount > 0).reduce((s,t) => s + t.amount, 0);
          const totalOut = qbYearData.filter(t => t.amount < 0).reduce((s,t) => s + t.amount, 0);

          const toggleGroup = (group) => setQbExpandedGroups(prev => ({...prev, [group]: !prev[group]}));

          // Monthly summary
          const byMonth = {};
          qbYearData.forEach(tx => {
            const m = tx.date.slice(0,7);
            if (!byMonth[m]) byMonth[m] = { in: 0, out: 0 };
            if (tx.amount > 0) byMonth[m].in += tx.amount;
            else byMonth[m].out += tx.amount;
          });

          return (
            <div>
              <div style={{ display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:18 }}>
                <h2 style={{ fontSize:14,textTransform:"uppercase",letterSpacing:1.5,color:"#c8a23c",margin:0,fontWeight:700 }}>QuickBooks — {qbSelectedYear}</h2>
                <div style={{ display:"flex",gap:6 }}>
                  {["2025","2026"].map(y => (
                    <button key={y} onClick={() => { setQbSelectedYear(y); loadQbYear(y); }}
                      style={{ padding:"5px 14px",borderRadius:5,border:"1px solid",cursor:"pointer",fontSize:12,fontWeight:600,
                        borderColor: qbSelectedYear===y ? "#c8a23c" : "#2a3040",
                        background: qbSelectedYear===y ? "#c8a23c20" : "transparent",
                        color: qbSelectedYear===y ? "#c8a23c" : "#64748b" }}>{y}</button>
                  ))}
                </div>
              </div>

              {qbYearLoading && <div style={{ fontSize:13,color:"#c8a23c",padding:"20px 0",textAlign:"center" }}>Loading QuickBooks data...</div>}

              {!qbYearLoading && qbYearData.length === 0 && (
                <div style={{ background:"#151a26",borderRadius:10,border:"1px solid #1e2536",padding:"40px",textAlign:"center" }}>
                  <div style={{ fontSize:14,color:"#64748b" }}>No QuickBooks data loaded for {qbSelectedYear}.</div>
                  <div style={{ fontSize:12,color:"#475569",marginTop:8 }}>Import transactions via CSV upload to see them here.</div>
                </div>
              )}

              {!qbYearLoading && qbYearData.length > 0 && (
                <div>
                  {/* Summary cards */}
                  <div style={{ display:"flex",gap:14,flexWrap:"wrap",marginBottom:20 }}>
                    {statCard("Total Money In", totalIn, "#22c55e", `${qbYearData.filter(t=>t.amount>0).length} transactions`)}
                    {statCard("Total Money Out", Math.abs(totalOut), "#ef4444", `${qbYearData.filter(t=>t.amount<0).length} transactions`)}
                    {statCard("Net Cash Flow", totalIn + totalOut, totalIn + totalOut >= 0 ? "#3b82f6" : "#f59e0b", `${qbYearData.length} total transactions`)}
                  </div>

                  {/* Monthly cash flow bar */}
                  <div style={{ background:"#151a26",borderRadius:10,border:"1px solid #1e2536",padding:"18px 22px",marginBottom:16 }}>
                    <div style={{ fontSize:12,fontWeight:700,color:"#c8a23c",textTransform:"uppercase",letterSpacing:1,marginBottom:14 }}>Monthly Cash Flow</div>
                    <div style={{ display:"flex",gap:8,alignItems:"flex-end",height:120 }}>
                      {Object.entries(byMonth).sort(([a],[b])=>a.localeCompare(b)).map(([m, d]) => {
                        const maxVal = Math.max(...Object.values(byMonth).map(v => Math.max(v.in, Math.abs(v.out))));
                        const inH = maxVal > 0 ? (d.in / maxVal) * 100 : 0;
                        const outH = maxVal > 0 ? (Math.abs(d.out) / maxVal) * 100 : 0;
                        return (
                          <div key={m} style={{ flex:1,display:"flex",flexDirection:"column",alignItems:"center",gap:2 }}>
                            <div style={{ width:"100%",display:"flex",gap:2,alignItems:"flex-end",height:100 }}>
                              <div style={{ flex:1,background:"#22c55e30",borderRadius:"3px 3px 0 0",height:`${inH}%`,minHeight: d.in > 0 ? 4 : 0 }} />
                              <div style={{ flex:1,background:"#ef444430",borderRadius:"3px 3px 0 0",height:`${outH}%`,minHeight: Math.abs(d.out) > 0 ? 4 : 0 }} />
                            </div>
                            <span style={{ fontSize:9,color:"#64748b" }}>{MONTHS[parseInt(m.slice(5))-1]}</span>
                          </div>
                        );
                      })}
                    </div>
                    <div style={{ display:"flex",gap:16,marginTop:10,justifyContent:"center",fontSize:11 }}>
                      <span style={{ color:"#22c55e" }}>■ Money In</span>
                      <span style={{ color:"#ef4444" }}>■ Money Out</span>
                    </div>
                  </div>

                  {/* Revenue groups */}
                  <div style={{ fontSize:12,fontWeight:700,color:"#22c55e",textTransform:"uppercase",letterSpacing:1,margin:"20px 0 10px",paddingBottom:6,borderBottom:"1px solid #1e2536" }}>Revenue</div>
                  {allGroups.filter(g => revenueGroups.includes(g) || (g === "Other" && grouped[g]?.some(t => t.amount > 0))).map(group => {
                    const txs = (grouped[group] || []).filter(t => group === "Other" ? t.amount > 0 : true);
                    if (txs.length === 0) return null;
                    const total = txs.reduce((s,t) => s + t.amount, 0);
                    const expanded = qbExpandedGroups[group];
                    return (
                      <div key={group} style={{ background:"#151a26",borderRadius:10,border:"1px solid #1e2536",marginBottom:8,overflow:"hidden" }}>
                        <div onClick={() => toggleGroup(group)} style={{ display:"flex",alignItems:"center",justifyContent:"space-between",padding:"12px 18px",cursor:"pointer",transition:"background 0.15s" }}
                          onMouseEnter={e => e.currentTarget.style.background="#1a2030"}
                          onMouseLeave={e => e.currentTarget.style.background="transparent"}>
                          <div style={{ display:"flex",alignItems:"center",gap:10 }}>
                            <span style={{ color:"#64748b",fontSize:10,transition:"transform 0.2s",transform: expanded ? "rotate(90deg)" : "rotate(0deg)" }}>▶</span>
                            <span style={{ fontWeight:600,fontSize:14 }}>{group}</span>
                            <span style={{ fontSize:11,color:"#475569",background:"#1a1f2e",padding:"2px 8px",borderRadius:3 }}>{txs.length}</span>
                          </div>
                          <span style={{ fontFamily:"'JetBrains Mono',monospace",fontSize:16,fontWeight:700,color:"#22c55e" }}>{fmt(total)}</span>
                        </div>
                        {expanded && (
                          <div style={{ borderTop:"1px solid #1e2536",padding:"8px 18px 12px" }}>
                            {txs.sort((a,b) => a.date.localeCompare(b.date)).map(tx => (
                              <div key={tx.id} style={{ display:"flex",alignItems:"center",justifyContent:"space-between",padding:"5px 0",fontSize:12,borderBottom:"1px solid #0f1219" }}>
                                <div style={{ display:"flex",alignItems:"center",gap:8,flexWrap:"wrap",flex:1,minWidth:0 }}>
                                  <span style={{ color:"#64748b",minWidth:70 }}>{tx.date.slice(5)}</span>
                                  <span style={{ color:"#e2e8f0",fontWeight:500 }}>{tx.name || "—"}</span>
                                  <span style={{ color:"#475569",fontSize:10,padding:"1px 6px",borderRadius:3,background:"#0f1219" }}>{tx.category}</span>
                                  {tx.class && <span style={{ color:"#c8a23c",fontSize:10,padding:"1px 6px",borderRadius:3,background:"#2a2210",border:"1px solid #3d3510" }}>{tx.class}</span>}
                                </div>
                                <span style={{ fontFamily:"'JetBrains Mono',monospace",color:"#22c55e",marginLeft:10 }}>{fmt(tx.amount)}</span>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    );
                  })}

                  {/* Expense groups */}
                  <div style={{ fontSize:12,fontWeight:700,color:"#ef4444",textTransform:"uppercase",letterSpacing:1,margin:"20px 0 10px",paddingBottom:6,borderBottom:"1px solid #1e2536" }}>Expenses</div>
                  {allGroups.filter(g => expenseGroups.includes(g) || (g === "Other" && grouped[g]?.some(t => t.amount < 0))).map(group => {
                    const txs = (grouped[group] || []).filter(t => group === "Other" ? t.amount < 0 : true);
                    if (txs.length === 0) return null;
                    const total = txs.reduce((s,t) => s + t.amount, 0);
                    const expanded = qbExpandedGroups[group + "_exp"];
                    return (
                      <div key={group+"_exp"} style={{ background:"#151a26",borderRadius:10,border:"1px solid #1e2536",marginBottom:8,overflow:"hidden" }}>
                        <div onClick={() => toggleGroup(group + "_exp")} style={{ display:"flex",alignItems:"center",justifyContent:"space-between",padding:"12px 18px",cursor:"pointer",transition:"background 0.15s" }}
                          onMouseEnter={e => e.currentTarget.style.background="#1a2030"}
                          onMouseLeave={e => e.currentTarget.style.background="transparent"}>
                          <div style={{ display:"flex",alignItems:"center",gap:10 }}>
                            <span style={{ color:"#64748b",fontSize:10,transition:"transform 0.2s",transform: expanded ? "rotate(90deg)" : "rotate(0deg)" }}>▶</span>
                            <span style={{ fontWeight:600,fontSize:14 }}>{group}</span>
                            <span style={{ fontSize:11,color:"#475569",background:"#1a1f2e",padding:"2px 8px",borderRadius:3 }}>{txs.length}</span>
                          </div>
                          <span style={{ fontFamily:"'JetBrains Mono',monospace",fontSize:16,fontWeight:700,color:"#ef4444" }}>{fmt(Math.abs(total))}</span>
                        </div>
                        {expanded && (
                          <div style={{ borderTop:"1px solid #1e2536",padding:"8px 18px 12px" }}>
                            {txs.sort((a,b) => a.date.localeCompare(b.date)).map(tx => (
                              <div key={tx.id} style={{ display:"flex",alignItems:"center",justifyContent:"space-between",padding:"5px 0",fontSize:12,borderBottom:"1px solid #0f1219" }}>
                                <div style={{ display:"flex",alignItems:"center",gap:8,flexWrap:"wrap",flex:1,minWidth:0 }}>
                                  <span style={{ color:"#64748b",minWidth:70 }}>{tx.date.slice(5)}</span>
                                  <span style={{ color:"#e2e8f0",fontWeight:500 }}>{tx.name || "—"}</span>
                                  <span style={{ color:"#475569",fontSize:10,padding:"1px 6px",borderRadius:3,background:"#0f1219" }}>{tx.category}</span>
                                  {tx.class && <span style={{ color:"#c8a23c",fontSize:10,padding:"1px 6px",borderRadius:3,background:"#2a2210",border:"1px solid #3d3510" }}>{tx.class}</span>}
                                </div>
                                <span style={{ fontFamily:"'JetBrains Mono',monospace",color:"#ef4444",marginLeft:10 }}>{fmt(Math.abs(tx.amount))}</span>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })()}

        {/* SETTINGS VIEW */}
        {view === "settings" && (
          <div>
            <h2 style={{ fontSize:14,textTransform:"uppercase",letterSpacing:1.5,color:"#c8a23c",margin:"0 0 18px",fontWeight:700 }}>Settings</h2>

            {/* QuickBooks Connection */}
            <div style={{ background:"#151a26",borderRadius:10,border:"1px solid #1e2536",padding:"22px 26px",marginBottom:16 }}>
              <div style={{ display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:16 }}>
                <div>
                  <div style={{ fontWeight:700,fontSize:16,marginBottom:4 }}>QuickBooks Online</div>
                  <div style={{ fontSize:12,color:"#64748b" }}>
                    {qbConnected
                      ? <span style={{ color:"#22c55e" }}>Connected</span>
                      : <span style={{ color:"#f59e0b" }}>Not connected</span>
                    }
                  </div>
                </div>
                {qbConnected ? (
                  <button onClick={async () => {
                    await api.disconnectQB();
                    setQbConnected(false);
                    setQbAccounts([]);
                    setQbTransactions(null);
                    setQbBalances([]);
                  }} style={{ padding:"8px 16px",borderRadius:6,border:"1px solid #7f1d1d",background:"transparent",color:"#ef4444",cursor:"pointer",fontSize:12,fontWeight:600 }}>
                    Disconnect
                  </button>
                ) : (
                  <button onClick={async () => {
                    setQbLoading(true);
                    try {
                      const { authUrl } = await api.getQBAuthUrl();
                      window.location.href = authUrl;
                    } catch (err) {
                      setQbError("Failed to start connection: " + err.message);
                      setQbLoading(false);
                    }
                  }} disabled={qbLoading} style={{ padding:"8px 20px",borderRadius:6,border:"none",background:"#2CA01C",color:"white",cursor:qbLoading?"wait":"pointer",fontSize:13,fontWeight:700 }}>
                    {qbLoading ? "Connecting..." : "Connect to QuickBooks"}
                  </button>
                )}
              </div>
              {qbError && <div style={{ fontSize:12,color:"#ef4444",marginBottom:12,padding:"8px 12px",background:"#1a1010",borderRadius:6,border:"1px solid #3d1010" }}>{qbError}</div>}

              {qbConnected && (
                <div>
                  <div style={{ borderTop:"1px solid #1e2536",paddingTop:16,display:"flex",gap:10,flexWrap:"wrap" }}>
                    <button onClick={async () => {
                      setQbLoading(true); setQbError(null);
                      try { const data = await api.getQBBalances(); setQbBalances(data); } catch(e) { setQbError(e.message); }
                      setQbLoading(false);
                    }} style={{ padding:"7px 16px",borderRadius:6,border:"1px solid #2a3040",background:"transparent",color:"#94a3b8",cursor:"pointer",fontSize:12,fontWeight:600 }}>
                      Fetch Bank Balances
                    </button>
                    <button onClick={async () => {
                      setQbLoading(true); setQbError(null);
                      try { const data = await api.getQBAccounts(); setQbAccounts(data); } catch(e) { setQbError(e.message); }
                      setQbLoading(false);
                    }} style={{ padding:"7px 16px",borderRadius:6,border:"1px solid #2a3040",background:"transparent",color:"#94a3b8",cursor:"pointer",fontSize:12,fontWeight:600 }}>
                      Fetch Chart of Accounts
                    </button>
                    <button onClick={async () => {
                      setQbLoading(true); setQbError(null);
                      try { const data = await api.getQBTransactions(qbDateRange.startDate, qbDateRange.endDate); setQbTransactions(data); } catch(e) { setQbError(e.message); }
                      setQbLoading(false);
                    }} style={{ padding:"7px 16px",borderRadius:6,border:"1px solid #2a3040",background:"transparent",color:"#94a3b8",cursor:"pointer",fontSize:12,fontWeight:600 }}>
                      Fetch Transactions
                    </button>
                  </div>

                  {/* Date range for QB queries */}
                  <div style={{ marginTop:12,display:"flex",gap:10,alignItems:"center",fontSize:12 }}>
                    <span style={{ color:"#64748b" }}>Date range:</span>
                    <input type="date" value={qbDateRange.startDate} onChange={e => setQbDateRange(d => ({...d, startDate: e.target.value}))}
                      style={{ padding:"5px 8px",borderRadius:5,border:"1px solid #2a3040",background:"#0f1219",color:"#e2e8f0",fontSize:12 }} />
                    <span style={{ color:"#64748b" }}>to</span>
                    <input type="date" value={qbDateRange.endDate} onChange={e => setQbDateRange(d => ({...d, endDate: e.target.value}))}
                      style={{ padding:"5px 8px",borderRadius:5,border:"1px solid #2a3040",background:"#0f1219",color:"#e2e8f0",fontSize:12 }} />
                  </div>

                  {qbLoading && <div style={{ marginTop:12,fontSize:12,color:"#c8a23c" }}>Loading from QuickBooks...</div>}
                </div>
              )}
            </div>

            {/* QB Bank Balances */}
            {qbBalances.length > 0 && (
              <div style={{ background:"#151a26",borderRadius:10,border:"1px solid #1e2536",padding:"22px 26px",marginBottom:16 }}>
                <h3 style={{ fontSize:13,textTransform:"uppercase",letterSpacing:1.2,color:"#c8a23c",margin:"0 0 14px",fontWeight:700 }}>QuickBooks Bank Balances</h3>
                {qbBalances.map(acct => (
                  <div key={acct.id} style={{ display:"flex",justifyContent:"space-between",padding:"8px 0",borderBottom:"1px solid #1a1f2e",fontSize:13 }}>
                    <span style={{ color:"#e2e8f0" }}>{acct.name}</span>
                    <span style={{ fontFamily:"'JetBrains Mono',monospace",color: acct.balance >= 0 ? "#22c55e" : "#ef4444",fontWeight:600 }}>{fmt(acct.balance)}</span>
                  </div>
                ))}
              </div>
            )}

            {/* QB Chart of Accounts */}
            {qbAccounts.length > 0 && (
              <div style={{ background:"#151a26",borderRadius:10,border:"1px solid #1e2536",padding:"22px 26px",marginBottom:16 }}>
                <h3 style={{ fontSize:13,textTransform:"uppercase",letterSpacing:1.2,color:"#c8a23c",margin:"0 0 14px",fontWeight:700 }}>QuickBooks Chart of Accounts</h3>
                <table style={{ width:"100%",borderCollapse:"collapse",fontSize:12 }}>
                  <thead>
                    <tr style={{ borderBottom:"1px solid #1e2536" }}>
                      {["Name","Type","Classification","Balance"].map(h => (
                        <th key={h} style={{ padding:"8px 10px",textAlign:h==="Balance"?"right":"left",color:"#64748b",fontWeight:600,fontSize:11,textTransform:"uppercase" }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {qbAccounts.map(acct => (
                      <tr key={acct.id} style={{ borderBottom:"1px solid #1a1f2e" }}>
                        <td style={{ padding:"6px 10px",color:"#e2e8f0" }}>{acct.fullName}</td>
                        <td style={{ padding:"6px 10px",color:"#94a3b8" }}>{acct.type}</td>
                        <td style={{ padding:"6px 10px",color:"#94a3b8" }}>{acct.classification}</td>
                        <td style={{ padding:"6px 10px",textAlign:"right",fontFamily:"'JetBrains Mono',monospace",color: acct.balance >= 0 ? "#22c55e" : "#ef4444" }}>{fmt(acct.balance || 0)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {/* QB Transactions */}
            {qbTransactions && (
              <div style={{ background:"#151a26",borderRadius:10,border:"1px solid #1e2536",padding:"22px 26px",marginBottom:16 }}>
                <h3 style={{ fontSize:13,textTransform:"uppercase",letterSpacing:1.2,color:"#c8a23c",margin:"0 0 14px",fontWeight:700 }}>
                  QuickBooks Transactions ({qbTransactions.dateRange.startDate} to {qbTransactions.dateRange.endDate})
                </h3>

                {/* Deposits */}
                {qbTransactions.deposits.length > 0 && (
                  <div style={{ marginBottom:16 }}>
                    <div style={{ fontSize:12,fontWeight:700,color:"#22c55e",marginBottom:8,textTransform:"uppercase",letterSpacing:0.8 }}>Deposits ({qbTransactions.deposits.length})</div>
                    {qbTransactions.deposits.map((d,i) => (
                      <div key={i} style={{ display:"flex",justifyContent:"space-between",padding:"5px 0",fontSize:12,borderBottom:"1px solid #1a1f2e" }}>
                        <div style={{ display:"flex",gap:12 }}>
                          <span style={{ color:"#64748b" }}>{d.TxnDate}</span>
                          <span style={{ color:"#e2e8f0" }}>{d.PrivateNote || "Deposit"}</span>
                        </div>
                        <span style={{ fontFamily:"'JetBrains Mono',monospace",color:"#22c55e" }}>{fmt(d.TotalAmt)}</span>
                      </div>
                    ))}
                  </div>
                )}

                {/* Purchases/Expenses */}
                {qbTransactions.purchases.length > 0 && (
                  <div style={{ marginBottom:16 }}>
                    <div style={{ fontSize:12,fontWeight:700,color:"#ef4444",marginBottom:8,textTransform:"uppercase",letterSpacing:0.8 }}>Expenses ({qbTransactions.purchases.length})</div>
                    {qbTransactions.purchases.map((p,i) => (
                      <div key={i} style={{ display:"flex",justifyContent:"space-between",padding:"5px 0",fontSize:12,borderBottom:"1px solid #1a1f2e" }}>
                        <div style={{ display:"flex",gap:12 }}>
                          <span style={{ color:"#64748b" }}>{p.TxnDate}</span>
                          <span style={{ color:"#e2e8f0" }}>{p.EntityRef?.name || p.PaymentType || "Expense"}</span>
                          {p.PrivateNote && <span style={{ color:"#475569" }}>· {p.PrivateNote}</span>}
                        </div>
                        <span style={{ fontFamily:"'JetBrains Mono',monospace",color:"#ef4444" }}>{fmt(p.TotalAmt)}</span>
                      </div>
                    ))}
                  </div>
                )}

                {/* Invoices */}
                {qbTransactions.invoices.length > 0 && (
                  <div style={{ marginBottom:16 }}>
                    <div style={{ fontSize:12,fontWeight:700,color:"#3b82f6",marginBottom:8,textTransform:"uppercase",letterSpacing:0.8 }}>Invoices ({qbTransactions.invoices.length})</div>
                    {qbTransactions.invoices.map((inv,i) => (
                      <div key={i} style={{ display:"flex",justifyContent:"space-between",padding:"5px 0",fontSize:12,borderBottom:"1px solid #1a1f2e" }}>
                        <div style={{ display:"flex",gap:12 }}>
                          <span style={{ color:"#64748b" }}>{inv.TxnDate}</span>
                          <span style={{ color:"#e2e8f0" }}>{inv.CustomerRef?.name || "Invoice"} #{inv.DocNumber}</span>
                          <span style={{ color: inv.Balance === 0 ? "#22c55e" : "#f59e0b",fontSize:11,padding:"1px 6px",borderRadius:3,background:"#1a1f2e" }}>
                            {inv.Balance === 0 ? "Paid" : `Due: ${fmt(inv.Balance)}`}
                          </span>
                        </div>
                        <span style={{ fontFamily:"'JetBrains Mono',monospace",color:"#3b82f6" }}>{fmt(inv.TotalAmt)}</span>
                      </div>
                    ))}
                  </div>
                )}

                {/* Bills */}
                {qbTransactions.bills.length > 0 && (
                  <div style={{ marginBottom:16 }}>
                    <div style={{ fontSize:12,fontWeight:700,color:"#a78bfa",marginBottom:8,textTransform:"uppercase",letterSpacing:0.8 }}>Bills ({qbTransactions.bills.length})</div>
                    {qbTransactions.bills.map((b,i) => (
                      <div key={i} style={{ display:"flex",justifyContent:"space-between",padding:"5px 0",fontSize:12,borderBottom:"1px solid #1a1f2e" }}>
                        <div style={{ display:"flex",gap:12 }}>
                          <span style={{ color:"#64748b" }}>{b.TxnDate}</span>
                          <span style={{ color:"#e2e8f0" }}>{b.VendorRef?.name || "Bill"}</span>
                          <span style={{ color: b.Balance === 0 ? "#22c55e" : "#f59e0b",fontSize:11,padding:"1px 6px",borderRadius:3,background:"#1a1f2e" }}>
                            {b.Balance === 0 ? "Paid" : `Due: ${fmt(b.Balance)}`}
                          </span>
                        </div>
                        <span style={{ fontFamily:"'JetBrains Mono',monospace",color:"#a78bfa" }}>{fmt(b.TotalAmt)}</span>
                      </div>
                    ))}
                  </div>
                )}

                {/* Journal Entries */}
                {qbTransactions.journals.length > 0 && (
                  <div>
                    <div style={{ fontSize:12,fontWeight:700,color:"#94a3b8",marginBottom:8,textTransform:"uppercase",letterSpacing:0.8 }}>Journal Entries ({qbTransactions.journals.length})</div>
                    {qbTransactions.journals.map((j,i) => (
                      <div key={i} style={{ display:"flex",justifyContent:"space-between",padding:"5px 0",fontSize:12,borderBottom:"1px solid #1a1f2e" }}>
                        <div style={{ display:"flex",gap:12 }}>
                          <span style={{ color:"#64748b" }}>{j.TxnDate}</span>
                          <span style={{ color:"#e2e8f0" }}>JE #{j.DocNumber}</span>
                          {j.PrivateNote && <span style={{ color:"#475569" }}>· {j.PrivateNote}</span>}
                        </div>
                        <span style={{ fontFamily:"'JetBrains Mono',monospace",color:"#94a3b8" }}>{fmt(j.TotalAmt)}</span>
                      </div>
                    ))}
                  </div>
                )}

                {qbTransactions.deposits.length === 0 && qbTransactions.purchases.length === 0 && qbTransactions.invoices.length === 0 && qbTransactions.bills.length === 0 && qbTransactions.journals.length === 0 && (
                  <div style={{ fontSize:13,color:"#475569",padding:"20px 0",textAlign:"center" }}>No transactions found for this date range.</div>
                )}
              </div>
            )}
          </div>
        )}
      </div>

      {/* Transaction Modal */}
      <Modal open={!!modal} onClose={() => setModal(null)}>
        {modal && (
          <div>
            <h3 style={{ margin:"0 0 4px",fontSize:17,fontWeight:700,color:"#e2e8f0" }}>{editTx ? "Edit" : "Add"} Transaction</h3>
            <div style={{ fontSize:12,color:"#64748b",marginBottom:20 }}>{modal.item.name} · {modal.item.acct}</div>
            <div style={{ display:"flex",flexDirection:"column",gap:14 }}>
              <div>
                <label style={{ display:"block",fontSize:11,color:"#94a3b8",marginBottom:4,textTransform:"uppercase",letterSpacing:0.8 }}>Amount ($)</label>
                <input type="number" value={form.amount} onChange={e => setForm({...form, amount: e.target.value})} placeholder="0.00"
                  style={{ width:"100%",padding:"10px 12px",borderRadius:6,border:"1px solid #2a3040",background:"#0f1219",color:"#e2e8f0",fontSize:16,fontFamily:"'JetBrains Mono',monospace",boxSizing:"border-box" }} />
              </div>
              <div>
                <label style={{ display:"block",fontSize:11,color:"#94a3b8",marginBottom:4,textTransform:"uppercase",letterSpacing:0.8 }}>Date</label>
                <input type="date" value={form.date} onChange={e => setForm({...form, date: e.target.value})}
                  style={{ width:"100%",padding:"10px 12px",borderRadius:6,border:"1px solid #2a3040",background:"#0f1219",color:"#e2e8f0",fontSize:14,boxSizing:"border-box" }} />
              </div>
              <div>
                <label style={{ display:"block",fontSize:11,color:"#94a3b8",marginBottom:4,textTransform:"uppercase",letterSpacing:0.8 }}>{modal.side === "revenue" ? "Payer" : "Payee"}</label>
                <input type="text" value={form.payerPayee} onChange={e => setForm({...form, payerPayee: e.target.value})} placeholder="Name or organization"
                  style={{ width:"100%",padding:"10px 12px",borderRadius:6,border:"1px solid #2a3040",background:"#0f1219",color:"#e2e8f0",fontSize:14,boxSizing:"border-box" }} />
              </div>
              <div>
                <label style={{ display:"block",fontSize:11,color:"#94a3b8",marginBottom:4,textTransform:"uppercase",letterSpacing:0.8 }}>Status</label>
                <div style={{ display:"flex",gap:6,flexWrap:"wrap" }}>
                  {(modal.side === "revenue" ? REV_STATUSES : EXP_STATUSES).map(s => (
                    <button key={s} onClick={() => setForm({...form, status: s})}
                      style={{
                        padding:"7px 14px",borderRadius:6,border:"1px solid",cursor:"pointer",fontSize:12,fontWeight:600,transition:"all 0.15s",
                        borderColor: form.status === s ? STATUS_COLORS[s] : "#2a3040",
                        background: form.status === s ? STATUS_COLORS[s] + "20" : "transparent",
                        color: form.status === s ? STATUS_COLORS[s] : "#64748b",
                      }}>
                      {s}
                    </button>
                  ))}
                </div>
              </div>
              <div>
                <label style={{ display:"block",fontSize:11,color:"#94a3b8",marginBottom:4,textTransform:"uppercase",letterSpacing:0.8 }}>Notes (optional)</label>
                <input type="text" value={form.notes} onChange={e => setForm({...form, notes: e.target.value})} placeholder="Reference, invoice #, etc."
                  style={{ width:"100%",padding:"10px 12px",borderRadius:6,border:"1px solid #2a3040",background:"#0f1219",color:"#e2e8f0",fontSize:14,boxSizing:"border-box" }} />
              </div>
            </div>
            <div style={{ display:"flex",gap:10,marginTop:22,justifyContent:"space-between" }}>
              <div>
                {editTx && (
                  <button onClick={() => deleteTx(editTx.id)}
                    style={{ padding:"10px 18px",borderRadius:6,border:"1px solid #7f1d1d",background:"transparent",color:"#ef4444",cursor:"pointer",fontSize:13,fontWeight:600 }}>
                    Delete
                  </button>
                )}
              </div>
              <div style={{ display:"flex",gap:10 }}>
                <button onClick={() => setModal(null)}
                  style={{ padding:"10px 18px",borderRadius:6,border:"1px solid #2a3040",background:"transparent",color:"#94a3b8",cursor:"pointer",fontSize:13 }}>
                  Cancel
                </button>
                <button onClick={submitTx}
                  style={{ padding:"10px 22px",borderRadius:6,border:"none",background:"#c8a23c",color:"#0f1219",cursor:"pointer",fontSize:13,fontWeight:700 }}>
                  {editTx ? "Update" : "Save"}
                </button>
              </div>
            </div>
          </div>
        )}
      </Modal>

      {/* Bank Balance Modal */}
      <Modal open={bankModal} onClose={() => setBankModal(false)}>
        <h3 style={{ margin:"0 0 16px",fontSize:17,fontWeight:700,color:"#e2e8f0" }}>Set Bank Balance</h3>
        <p style={{ fontSize:13,color:"#94a3b8",margin:"0 0 16px" }}>Enter the current balance from your bank statement. This is the actual cash in the account.</p>
        <input type="number" value={bankInput} onChange={e => setBankInput(e.target.value)} placeholder="0.00"
          style={{ width:"100%",padding:"12px",borderRadius:6,border:"1px solid #2a3040",background:"#0f1219",color:"#e2e8f0",fontSize:20,fontFamily:"'JetBrains Mono',monospace",marginBottom:16,boxSizing:"border-box" }} />
        <div style={{ display:"flex",gap:10,justifyContent:"flex-end" }}>
          <button onClick={() => setBankModal(false)}
            style={{ padding:"10px 18px",borderRadius:6,border:"1px solid #2a3040",background:"transparent",color:"#94a3b8",cursor:"pointer",fontSize:13 }}>Cancel</button>
          <button onClick={() => { saveBankBalance(parseFloat(bankInput) || 0); setBankModal(false); }}
            style={{ padding:"10px 22px",borderRadius:6,border:"none",background:"#c8a23c",color:"#0f1219",cursor:"pointer",fontSize:13,fontWeight:700 }}>Save</button>
        </div>
      </Modal>

      {/* Revenue Budget Detail Modal */}
      <Modal open={revBudgetModal} onClose={() => setRevBudgetModal(false)}>
        <h3 style={{ margin:"0 0 4px",fontSize:17,fontWeight:700,color:"#e2e8f0" }}>Revenue Budget Detail</h3>
        <div style={{ fontSize:12,color:"#64748b",marginBottom:16 }}>2026 Revenue — Budget vs. Actual</div>
        <table style={{ width:"100%",borderCollapse:"collapse",fontSize:13 }}>
          <thead>
            <tr style={{ borderBottom:"1px solid #1e2536" }}>
              {["Account","Budget","Actual","% Rcvd"].map(h => (
                <th key={h} style={{ padding:"8px 10px",textAlign:h==="Account"?"left":"right",color:"#64748b",fontWeight:600,fontSize:11,textTransform:"uppercase",letterSpacing:0.8 }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {BUDGET.revenue.map(rev => {
              const actual = txForItem(rev.id).reduce((s,t) => s + t.amount, 0);
              const pct = rev.budget > 0 ? Math.round((actual / rev.budget) * 100) : (actual > 0 ? 100 : 0);
              return (
                <tr key={rev.id} style={{ borderBottom:"1px solid #1a1f2e" }}>
                  <td style={{ padding:"8px 10px",color:"#e2e8f0",fontSize:12 }}>{rev.name}</td>
                  <td style={{ padding:"8px 10px",textAlign:"right",fontFamily:"'JetBrains Mono',monospace",color:"#94a3b8",fontSize:12 }}>{fmt(rev.budget)}</td>
                  <td style={{ padding:"8px 10px",textAlign:"right",fontFamily:"'JetBrains Mono',monospace",color: actual > 0 ? "#22c55e" : "#64748b",fontSize:12 }}>{actual > 0 ? fmt(actual) : "—"}</td>
                  <td style={{ padding:"8px 10px",textAlign:"right" }}>
                    <div style={{ display:"inline-flex",alignItems:"center",gap:6 }}>
                      <div style={{ width:40,height:5,borderRadius:3,background:"#1e2536",overflow:"hidden" }}>
                        <div style={{ width:`${Math.min(pct,100)}%`,height:"100%",borderRadius:3,background: pct >= 100 ? "#22c55e" : pct > 50 ? "#3b82f6" : "#f59e0b",transition:"width 0.3s" }} />
                      </div>
                      <span style={{ fontSize:11,color:"#64748b",fontFamily:"'JetBrains Mono',monospace",minWidth:28 }}>{pct}%</span>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
          <tfoot>
            <tr style={{ borderTop:"2px solid #2a3040" }}>
              <td style={{ padding:"10px 10px",color:"#e2e8f0",fontWeight:700,fontSize:12 }}>TOTAL</td>
              <td style={{ padding:"10px 10px",textAlign:"right",fontFamily:"'JetBrains Mono',monospace",color:"#e2e8f0",fontWeight:700,fontSize:12 }}>{fmt(totalBudgetRevenue)}</td>
              <td style={{ padding:"10px 10px",textAlign:"right",fontFamily:"'JetBrains Mono',monospace",color:"#22c55e",fontWeight:700,fontSize:12 }}>{fmt(totalReceived + totalConfirmedRev + totalPipeline)}</td>
              <td style={{ padding:"10px 10px",textAlign:"right" }}>
                {(() => {
                  const totalActual = totalReceived + totalConfirmedRev + totalPipeline;
                  const pct = totalBudgetRevenue > 0 ? Math.round((totalActual / totalBudgetRevenue) * 100) : 0;
                  return <span style={{ fontSize:11,color:"#64748b",fontFamily:"'JetBrains Mono',monospace" }}>{pct}%</span>;
                })()}
              </td>
            </tr>
          </tfoot>
        </table>
        <div style={{ display:"flex",justifyContent:"flex-end",marginTop:16 }}>
          <button onClick={() => setRevBudgetModal(false)}
            style={{ padding:"10px 22px",borderRadius:6,border:"none",background:"#c8a23c",color:"#0f1219",cursor:"pointer",fontSize:13,fontWeight:700 }}>Close</button>
        </div>
      </Modal>

      {/* Monthly Allocation Modal */}
      <Modal open={!!allocModal} onClose={() => setAllocModal(null)}>
        {allocModal && (() => {
          const item = allocModal.item;
          const formTotal = MONTHS.reduce((s,_,i) => s + (parseFloat(allocForm[String(i+1).padStart(2,"0")]) || 0), 0);
          const diff = item.budget - formTotal;
          const saveAlloc = async () => {
            const cleaned = {};
            MONTHS.forEach((_,i) => {
              const k = String(i+1).padStart(2,"0");
              const v = parseFloat(allocForm[k]) || 0;
              if (v > 0) cleaned[k] = v;
            });
            try {
              await api.saveAllocation(item.id, cleaned);
              setAllocations(prev => ({...prev, [item.id]: cleaned}));
            } catch(err) { console.error(err); }
            setAllocModal(null);
          };
          const spreadEvenly = () => {
            const monthly = Math.round((item.budget / 12) * 100) / 100;
            const form = {};
            MONTHS.forEach((_,i) => { form[String(i+1).padStart(2,"0")] = i < 11 ? monthly : Math.round((item.budget - monthly * 11) * 100) / 100; });
            setAllocForm(form);
          };
          const spreadLastN = (n) => {
            const startMonth = 12 - n;
            const monthly = Math.round((item.budget / n) * 100) / 100;
            const form = {};
            MONTHS.forEach((_,i) => {
              const k = String(i+1).padStart(2,"0");
              if (i >= startMonth) form[k] = i < 11 ? monthly : Math.round((item.budget - monthly * (n-1)) * 100) / 100;
              else form[k] = 0;
            });
            setAllocForm(form);
          };
          const spreadQuarterly = () => {
            const quarterly = Math.round((item.budget / 4) * 100) / 100;
            const form = {};
            MONTHS.forEach((_,i) => {
              const k = String(i+1).padStart(2,"0");
              form[k] = [2,5,8,11].includes(i) ? (i === 11 ? Math.round((item.budget - quarterly * 3) * 100) / 100 : quarterly) : 0;
            });
            setAllocForm(form);
          };
          const clearAll = () => { setAllocForm({}); };

          return (
            <div>
              <h3 style={{ margin:"0 0 4px",fontSize:17,fontWeight:700,color:"#e2e8f0" }}>Monthly Allocation</h3>
              <div style={{ fontSize:12,color:"#64748b",marginBottom:6 }}>{item.name}</div>
              <div style={{ display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16 }}>
                <div style={{ fontSize:13,fontFamily:"'JetBrains Mono',monospace" }}>
                  Budget: <span style={{ color:"#e2e8f0",fontWeight:700 }}>{fmt(item.budget)}</span>
                </div>
                <div style={{ fontSize:13,fontFamily:"'JetBrains Mono',monospace" }}>
                  Remaining: <span style={{ color: diff === 0 ? "#22c55e" : diff > 0 ? "#f59e0b" : "#ef4444", fontWeight:700 }}>{fmt(diff)}</span>
                </div>
              </div>

              {/* Progress bar */}
              <div style={{ height:6,borderRadius:3,background:"#1e2536",marginBottom:16,overflow:"hidden" }}>
                <div style={{ height:"100%",borderRadius:3,width:`${Math.min(100,item.budget > 0 ? (formTotal/item.budget)*100 : 0)}%`,background: diff === 0 ? "#22c55e" : diff > 0 ? "#c8a23c" : "#ef4444",transition:"width 0.3s" }} />
              </div>

              {/* Shortcut buttons */}
              <div style={{ display:"flex",gap:6,marginBottom:16,flexWrap:"wrap" }}>
                {[{label:"Spread Evenly",fn:spreadEvenly},{label:"Last 6 Months",fn:()=>spreadLastN(6)},{label:"Last 3 Months",fn:()=>spreadLastN(3)},{label:"Quarterly",fn:spreadQuarterly},{label:"Clear",fn:clearAll}].map(b => (
                  <button key={b.label} onClick={b.fn} style={{ padding:"5px 12px",borderRadius:5,border:"1px solid #2a3040",background:"transparent",color:"#94a3b8",cursor:"pointer",fontSize:11,fontWeight:600 }}>{b.label}</button>
                ))}
              </div>

              {/* Month inputs - 2 columns */}
              <div style={{ display:"grid",gridTemplateColumns:"1fr 1fr",gap:"8px 16px" }}>
                {MONTHS.map((m,i) => {
                  const k = String(i+1).padStart(2,"0");
                  const val = allocForm[k] || "";
                  const actual = transactions.filter(t => t.budgetId === item.id && t.date?.startsWith(`2026-${k}`)).reduce((s,t) => s + t.amount, 0);
                  const isPast = i < new Date().getMonth();
                  return (
                    <div key={m} style={{ display:"flex",alignItems:"center",gap:8 }}>
                      <span style={{ width:30,fontSize:12,color:"#64748b",fontWeight:600 }}>{m}</span>
                      <input type="number" value={val} onChange={e => setAllocForm(prev => ({...prev, [k]: e.target.value === "" ? "" : parseFloat(e.target.value)}))}
                        placeholder="0" style={{ flex:1,padding:"6px 8px",borderRadius:5,border:"1px solid #2a3040",background:"#0f1219",color:"#e2e8f0",fontSize:13,fontFamily:"'JetBrains Mono',monospace",boxSizing:"border-box",textAlign:"right" }} />
                      {isPast && actual > 0 && (
                        <span style={{ fontSize:10,color: allocModal.side === "revenue" ? "#22c55e" : "#ef4444",fontFamily:"'JetBrains Mono',monospace",minWidth:55,textAlign:"right" }}>{fmt(actual)}</span>
                      )}
                    </div>
                  );
                })}
              </div>

              {/* Total and save */}
              <div style={{ display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:18,paddingTop:14,borderTop:"1px solid #2a3040" }}>
                <div style={{ fontFamily:"'JetBrains Mono',monospace",fontSize:14 }}>
                  Total: <span style={{ color: diff === 0 ? "#22c55e" : "#f59e0b", fontWeight:700 }}>{fmt(formTotal)}</span>
                  <span style={{ color:"#64748b",fontSize:12 }}> / {fmt(item.budget)}</span>
                </div>
                <div style={{ display:"flex",gap:10 }}>
                  <button onClick={() => setAllocModal(null)} style={{ padding:"10px 18px",borderRadius:6,border:"1px solid #2a3040",background:"transparent",color:"#94a3b8",cursor:"pointer",fontSize:13 }}>Cancel</button>
                  <button onClick={saveAlloc} style={{ padding:"10px 22px",borderRadius:6,border:"none",background:"#c8a23c",color:"#0f1219",cursor:"pointer",fontSize:13,fontWeight:700 }}>Save</button>
                </div>
              </div>
            </div>
          );
        })()}
      </Modal>

      {/* Budget Item Modal */}
      <Modal open={!!budgetModal} onClose={() => setBudgetModal(null)}>
        {budgetModal && (() => {
          const isNew = budgetModal.mode === "new";
          const budgetAmt = parseFloat(budgetForm.amount) || 0;
          const monthTotal = MONTHS.reduce((s,_,i) => s + (parseFloat(budgetForm.months[String(i+1).padStart(2,"0")]) || 0), 0);
          const diff = budgetAmt - monthTotal;

          const spreadEvenly = () => {
            if (!budgetAmt) return;
            const monthly = Math.round((budgetAmt / 12) * 100) / 100;
            const m = {}; MONTHS.forEach((_,i) => { m[String(i+1).padStart(2,"0")] = i < 11 ? monthly : Math.round((budgetAmt - monthly * 11) * 100) / 100; });
            setBudgetForm(prev => ({...prev, months: m}));
          };
          const spreadLastN = (n) => {
            if (!budgetAmt) return;
            const start = 12 - n; const monthly = Math.round((budgetAmt / n) * 100) / 100;
            const m = {}; MONTHS.forEach((_,i) => { const k = String(i+1).padStart(2,"0"); m[k] = i >= start ? (i < 11 ? monthly : Math.round((budgetAmt - monthly * (n-1)) * 100) / 100) : 0; });
            setBudgetForm(prev => ({...prev, months: m}));
          };
          const spreadQuarterly = () => {
            if (!budgetAmt) return;
            const q = Math.round((budgetAmt / 4) * 100) / 100;
            const m = {}; MONTHS.forEach((_,i) => { m[String(i+1).padStart(2,"0")] = [2,5,8,11].includes(i) ? (i === 11 ? Math.round((budgetAmt - q * 3) * 100) / 100 : q) : 0; });
            setBudgetForm(prev => ({...prev, months: m}));
          };

          const saveBudgetItem = async () => {
            if (!budgetForm.name || !budgetAmt) return;
            const cleanMonths = {};
            MONTHS.forEach((_,i) => { const k = String(i+1).padStart(2,"0"); const v = parseFloat(budgetForm.months[k]) || 0; if (v > 0) cleanMonths[k] = v; });
            const item = { name: budgetForm.name, name2: budgetForm.name2 || "", amount: budgetAmt, date: budgetForm.date, ledger: budgetForm.ledger || "", qbRef: budgetForm.qbRef || "", payerPayee: budgetForm.payerPayee || "", notes: budgetForm.notes || "", side: budgetForm.side, months: cleanMonths };
            try {
              if (isNew) {
                const created = await api.createBudgetItem(item);
                setBudgetItems(prev => [...prev, created]);
              } else {
                item.id = budgetModal.item.id;
                await api.updateBudgetItem(item.id, item);
                setBudgetItems(prev => prev.map(b => b.id === item.id ? item : b));
              }
            } catch(err) { console.error(err); }
            setBudgetModal(null);
          };

          const deleteBudgetItem = async () => {
            const itemId = budgetModal.item?.id;
            if (!itemId) return;
            if (!window.confirm(`Delete "${budgetForm.name}"? This cannot be undone.`)) return;
            try {
              await api.deleteBudgetItem(itemId);
              setBudgetItems(prev => prev.filter(b => b.id !== itemId));
              setBudgetModal(null);
            } catch(err) { console.error(err); alert("Delete failed: " + err.message); }
          };

          const inputStyle = { width:"100%",padding:"8px 10px",borderRadius:5,border:"1px solid #2a3040",background:"#0f1219",color:"#e2e8f0",fontSize:13,boxSizing:"border-box" };
          const labelStyle = { display:"block",fontSize:10,color:"#94a3b8",marginBottom:3,textTransform:"uppercase",letterSpacing:0.8 };

          return (
            <div>
              <h3 style={{ margin:"0 0 4px",fontSize:17,fontWeight:700,color:"#e2e8f0" }}>{isNew ? "Add" : "Edit"} Budget Item</h3>
              <div style={{ fontSize:12,color:"#64748b",marginBottom:16 }}>{budgetForm.side === "revenue" ? "Revenue" : "Expense"}</div>

              <div style={{ display:"grid",gridTemplateColumns:"1fr 1fr",gap:"10px 14px",marginBottom:16 }}>
                <div style={{ gridColumn:"1/3" }}><label style={labelStyle}>Account Name *</label><input type="text" value={budgetForm.name} onChange={e => setBudgetForm(p=>({...p,name:e.target.value}))} placeholder="Budget line item name" style={inputStyle} /></div>
                <div><label style={labelStyle}>Secondary Account Name</label><input type="text" value={budgetForm.name2||""} onChange={e => setBudgetForm(p=>({...p,name2:e.target.value}))} placeholder="Optional" style={inputStyle} /></div>
                <div><label style={labelStyle}>Budget Amount *</label><input type="number" value={budgetForm.amount} onChange={e => setBudgetForm(p=>({...p,amount:e.target.value}))} placeholder="0.00" style={{...inputStyle,fontFamily:"'JetBrains Mono',monospace"}} /></div>
                <div><label style={labelStyle}>Date</label><input type="date" value={budgetForm.date} onChange={e => setBudgetForm(p=>({...p,date:e.target.value}))} max={new Date().toISOString().slice(0,10)} style={inputStyle} /></div>
                <div><label style={labelStyle}>Payer (optional)</label><input type="text" value={budgetForm.payerPayee||""} onChange={e => setBudgetForm(p=>({...p,payerPayee:e.target.value}))} style={inputStyle} /></div>
                <div><label style={labelStyle}>Ledger #</label><input type="text" value={budgetForm.ledger||""} onChange={e => setBudgetForm(p=>({...p,ledger:e.target.value}))} placeholder="For future use" style={inputStyle} /></div>
                <div><label style={labelStyle}>QuickBooks Ref</label><input type="text" value={budgetForm.qbRef||""} onChange={e => setBudgetForm(p=>({...p,qbRef:e.target.value}))} placeholder="For future use" maxLength={50} style={inputStyle} /></div>
                <div style={{ gridColumn:"1/3" }}><label style={labelStyle}>Notes</label><input type="text" value={budgetForm.notes||""} onChange={e => setBudgetForm(p=>({...p,notes:e.target.value}))} style={inputStyle} /></div>
              </div>

              {/* Monthly allocation */}
              <div style={{ borderTop:"1px solid #2a3040",paddingTop:14 }}>
                <div style={{ display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8 }}>
                  <span style={{ fontSize:12,fontWeight:600,color:"#94a3b8",textTransform:"uppercase",letterSpacing:0.8 }}>Monthly Allocation</span>
                  <span style={{ fontFamily:"'JetBrains Mono',monospace",fontSize:12,color: diff === 0 ? "#22c55e" : diff > 0 ? "#f59e0b" : "#ef4444" }}>Remaining: {fmt(diff)}</span>
                </div>
                <div style={{ height:5,borderRadius:3,background:"#1e2536",marginBottom:12,overflow:"hidden" }}>
                  <div style={{ height:"100%",borderRadius:3,width:`${Math.min(100,budgetAmt > 0 ? (monthTotal/budgetAmt)*100 : 0)}%`,background: diff === 0 ? "#22c55e" : diff > 0 ? "#c8a23c" : "#ef4444",transition:"width 0.3s" }} />
                </div>
                <div style={{ display:"flex",gap:6,marginBottom:12,flexWrap:"wrap" }}>
                  {[{label:"Spread Evenly",fn:spreadEvenly},{label:"Last 6 Months",fn:()=>spreadLastN(6)},{label:"Last 3 Months",fn:()=>spreadLastN(3)},{label:"Quarterly",fn:spreadQuarterly},{label:"Clear",fn:()=>setBudgetForm(p=>({...p,months:{}}))}].map(b => (
                    <button key={b.label} onClick={b.fn} style={{ padding:"4px 10px",borderRadius:4,border:"1px solid #2a3040",background:"transparent",color:"#94a3b8",cursor:"pointer",fontSize:10,fontWeight:600 }}>{b.label}</button>
                  ))}
                </div>
                <div style={{ display:"grid",gridTemplateColumns:"1fr 1fr",gap:"6px 20px" }}>
                  {[0,1,2,3,4,5].map(i => {
                    const k1 = String(i+1).padStart(2,"0");
                    const k2 = String(i+7).padStart(2,"0");
                    return (
                      <React.Fragment key={i}>
                        <div style={{ display:"flex",alignItems:"center",gap:6 }}>
                          <span style={{ width:26,fontSize:11,color:"#64748b",fontWeight:600 }}>{MONTHS[i]}</span>
                          <input type="number" value={budgetForm.months[k1]||""} onChange={e => setBudgetForm(p=>({...p,months:{...p.months,[k1]:e.target.value===""?"":parseFloat(e.target.value)}}))}
                            placeholder="0" style={{ flex:1,padding:"5px 7px",borderRadius:4,border:"1px solid #2a3040",background:"#0f1219",color:"#e2e8f0",fontSize:12,fontFamily:"'JetBrains Mono',monospace",textAlign:"right",boxSizing:"border-box" }} />
                        </div>
                        <div style={{ display:"flex",alignItems:"center",gap:6 }}>
                          <span style={{ width:26,fontSize:11,color:"#64748b",fontWeight:600 }}>{MONTHS[i+6]}</span>
                          <input type="number" value={budgetForm.months[k2]||""} onChange={e => setBudgetForm(p=>({...p,months:{...p.months,[k2]:e.target.value===""?"":parseFloat(e.target.value)}}))}
                            placeholder="0" style={{ flex:1,padding:"5px 7px",borderRadius:4,border:"1px solid #2a3040",background:"#0f1219",color:"#e2e8f0",fontSize:12,fontFamily:"'JetBrains Mono',monospace",textAlign:"right",boxSizing:"border-box" }} />
                        </div>
                      </React.Fragment>
                    );
                  })}
                </div>
                <div style={{ marginTop:10,fontSize:12,fontFamily:"'JetBrains Mono',monospace",textAlign:"right",color:"#94a3b8" }}>Total: <span style={{ color: diff === 0 ? "#22c55e" : "#f59e0b",fontWeight:700 }}>{fmt(monthTotal)}</span> / {fmt(budgetAmt)}</div>
              </div>

              <div style={{ display:"flex",gap:10,marginTop:18,justifyContent:"space-between",borderTop:"1px solid #2a3040",paddingTop:14 }}>
                <div>{!isNew && <button onClick={deleteBudgetItem} style={{ padding:"8px 16px",borderRadius:6,border:"1px solid #7f1d1d",background:"transparent",color:"#ef4444",cursor:"pointer",fontSize:12,fontWeight:600 }}>Delete</button>}</div>
                <div style={{ display:"flex",gap:10 }}>
                  <button onClick={() => setBudgetModal(null)} style={{ padding:"8px 16px",borderRadius:6,border:"1px solid #2a3040",background:"transparent",color:"#94a3b8",cursor:"pointer",fontSize:12 }}>Cancel</button>
                  <button onClick={saveBudgetItem} style={{ padding:"8px 20px",borderRadius:6,border:"none",background:"#c8a23c",color:"#0f1219",cursor:"pointer",fontSize:12,fontWeight:700 }}>{isNew ? "Add" : "Update"}</button>
                </div>
              </div>
            </div>
          );
        })()}
      </Modal>
    </div>
  );
}

// =============================================
// Root App with Auth
// =============================================
export default function App() {
  const [session, setSession] = useState(null);
  const [checking, setChecking] = useState(true);
  const [qbCode, setQbCode] = useState(null);

  useEffect(() => {
    // Check for QB OAuth callback
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    if (code && window.location.pathname === "/qb-callback") {
      setQbCode(code);
      window.history.replaceState(null, "", "/");
    }

    // Check for callback from Google/Cognito
    handleCallback();
    // Check existing session
    const s = getSession();
    setSession(s);
    setChecking(false);
  }, []);

  if (checking) {
    return <div style={{ background:"#0f1219",color:"#94a3b8",minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center" }}>Loading...</div>;
  }

  if (!session) {
    return <LoginScreen />;
  }

  return <QBoxFinance session={session} qbCode={qbCode} onQbCodeUsed={() => setQbCode(null)} />;
}
